import React, { useEffect, useState, useRef, useCallback, useMemo } from 'react';
import { profileAvatar } from "../component/ImageList";
import Footer from '../component/Footer';
import baseURL from "../component/baseURL";
import { useNavigate, useLocation, useBlocker } from 'react-router-dom';
import showNotification from '../component/Notification';
import { setAppLanguageAndNotify, profileLanguageLabelToCode } from '../utils/appLanguage';
import { ReactNotifications } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import Cropper from 'react-easy-crop';
import { getCroppedImg } from '../utils/cropImage';
import stringsoflanguages from '../component/stringsoflanguages';

export default function Profile() {


    const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [gearMenuOpen, setGearMenuOpen] = useState(false);
    const [gearSpinning, setGearSpinning] = useState(false);
    const [webSettingsGearOpen, setWebSettingsGearOpen] = useState(false);
    const [webSettingsGearSpinning, setWebSettingsGearSpinning] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [connectionCount, setconnectionCount] = useState(0);
    const [listingCount, setlistingCount] = useState(0);
    const [portfolioCount, setportfolioCount] = useState(0);
    const [loading, setLoading] = useState(true);
    const [userID, setUserID] = useState(null);
    const [userFName, setUserFName] = useState(null);
    const [userLName, setUserLName] = useState(null);
    const [userEmail, setUserEmail] = useState(null);
    const [userPicture, setUserPicture] = useState(null);
    const [profileImageBase64, setProfileImageBase64] = useState('');
    const [isUploadingProfileImage, setIsUploadingProfileImage] = useState(false);
    const [companyImageBase64, setCompanyImageBase64] = useState('');
    const [isUploadingCompanyImage, setIsUploadingCompanyImage] = useState(false);
    const [activeRightSection, setActiveRightSection] = useState('details');
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [oldEmail, setOldEmail] = useState('');
    const [newEmail, setNewEmail] = useState('');
    const [webBannerImage, setWebBannerImage] = useState('https://images.unsplash.com/photo-1555041469-a586c61ea9bc?q=80&w=1200&auto=format&fit=crop');
    const [webBannerHeading, setWebBannerHeading] = useState('Find Your Dream Home Change1');
    const [webBannerSubHeading, setWebBannerSubHeading] = useState('I am honoured and privileged to help you with your Real Estate needs');
    const [webCardHeading, setWebCardHeading] = useState('Trusted By Thousands');
    const [webCardDescription, setWebCardDescription] = useState('Aliquam dictum elit vitae mauris facilisi at dictum urna dignissim donec vel lectus vel felis');
    const [webSiteTitle, setWebSiteTitle] = useState('YESMLS - SUMANGAL');
    const [webSiteDescription, setWebSiteDescription] = useState('this is my new premium website');
    const [webDefaultLanguage, setWebDefaultLanguage] = useState('français');
    const [defaultThemeModalOpen, setDefaultThemeModalOpen] = useState(false);
    const [showEmailLockedModal, setShowEmailLockedModal] = useState(false);
    const [defaultThemeImages, setDefaultThemeImages] = useState([]);
    const [selectedThemeImage, setSelectedThemeImage] = useState('');
    const [userTitle, setUserTitle] = useState('');
    const [userGender, setUserGender] = useState('');
    const [userLanguage, setUserLanguage] = useState('');
    const [userPhone, setUserPhone] = useState('');
    const [userLicenceNumber, setUserLicenceNumber] = useState('');
    const [userSpokenLanguage, setUserSpokenLanguage] = useState('');
    const [userShortIntroduction, setUserShortIntroduction] = useState('');
    const [userAboutMe, setUserAboutMe] = useState('');
    const [userCity, setUserCity] = useState('');
    const [userCountry, setUserCountry] = useState('');
    const [userCompanyImage, setUserCompanyImage] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [userYearCreated, setUserYearCreated] = useState('');
    const [userCompanyWebsite, setUserCompanyWebsite] = useState('');
    const [userAgentCode, setUserAgentCode] = useState('');
    const [userState, setUserState] = useState('');
    const [userZipCode, setUserZipCode] = useState('');
    const [userStreet, setUserStreet] = useState('');
    const [userNumber, setUserNumber] = useState('');
    const [userWhatsapp, setUserWhatsapp] = useState('');
    const [userSkype, setUserSkype] = useState('');
    const [userFacebook, setUserFacebook] = useState('');
    const [userInstagram, setUserInstagram] = useState('');
    const [userTelegram, setUserTelegram] = useState('');
    const [userLinkedIn, setUserLinkedIn] = useState('');

    const [userStateId, setUserStateId] = useState('');
    const [userCityId, setUserCityId] = useState('');
    const [userCountryId, setUserCountryId] = useState('');

    const [countryList, setCountryList] = useState([]);
    const [stateList, setStateList] = useState([]);
    const [cityList, setCityList] = useState([]);

    const profileImageInputRef = useRef(null);
    const companyImageInputRef = useRef(null);
    const bannerImageInputRef = useRef(null);
    const favIconInputRef = useRef(null);
    const gearMenuRef = useRef(null);
    const webSettingsGearRef = useRef(null);
    const initialProfileRef = useRef(null);

    const leaveBlockerRef = useRef(null);
    const [isSavingOnLeave, setIsSavingOnLeave] = useState(false);
    const [showLeaveModalForReload, setShowLeaveModalForReload] = useState(false);

    const [isCropperOpen, setIsCropperOpen] = useState(false);
    const [cropperImageSrc, setCropperImageSrc] = useState('');
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [cropTarget, setCropTarget] = useState('profile'); // 'profile' | 'company'
    const isUploadingAnyImage = isUploadingProfileImage || isUploadingCompanyImage;


    const [favIconImageBase64, setFavIconImageBase64] = useState('');
    const [webFavIcon, setWebFavIcon] = useState('');
    const [bannerHeading, setBannerHeading] = useState('');
    const [bannerSubHeading, setBannerSubHeading] = useState('');
    const [tbtDescription, setTbtDescription] = useState('');
    const [cardHeading, setCardHeading] = useState('');
    const [siteTitle, setSiteTitle] = useState('');
    const [siteDescription, setSiteDescription] = useState('');
    const [showDefaultLanguage, setShowDefaultLanguage] = useState('');
    const [showDefaultLanguageName, setShowDefaultLanguageName] = useState('');
    const [defaultLanguage, setDefaultLanguage] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();

    const profileStatsNavState = useMemo(
        () => ({
            is_member: 1,
            member_id: userID || '',
            member_fname: userFName ?? '',
            member_lname: userLName ?? '',
        }),
        [userID, userFName, userLName]
    );

    const mobileHeaderTitle = useMemo(() => {
        if (activeRightSection === 'change-password') return 'Change Password';
        if (activeRightSection === 'change-email') return 'Change Email';
        if (activeRightSection === 'web-settings') return 'Web Settings';
        return 'Profile';
    }, [activeRightSection]);

    const profileSectionFromPath = useCallback((pathname) => {
        const p = String(pathname || '').toLowerCase();
        if (p.startsWith('/profile/change-password')) return 'change-password';
        if (p.startsWith('/profile/change-email')) return 'change-email';
        if (p.startsWith('/profile/web-settings')) return 'web-settings';
        return 'details';
    }, []);

    useEffect(() => {
        const next = profileSectionFromPath(location.pathname);
        setActiveRightSection(next);
    }, [location.pathname, profileSectionFromPath]);

    const isDirty = useMemo(() => {
        const init = initialProfileRef.current;
        if (!init) return false;
        return (
            (userFName ?? '') !== (init.fname ?? '') ||
            (userLName ?? '') !== (init.lname ?? '') ||
            (userEmail ?? '') !== (init.email ?? '') ||
            (userTitle ?? '') !== (init.title ?? '') ||
            (userGender ?? '') !== (init.gender ?? '') ||
            (userLanguage ?? '') !== (init.app_language ?? '') ||
            (userPhone ?? '') !== (init.phone ?? '') ||
            (userLicenceNumber ?? '') !== (init.licence_number ?? '') ||
            (userSpokenLanguage ?? '') !== (init.spoken_languages ?? '') ||
            (userShortIntroduction ?? '') !== (init.about_me ?? '') ||
            (userAboutMe ?? '') !== (init.who_am_i ?? '') ||
            (userCity ?? '') !== (init.city_name ?? '') ||
            (userCountry ?? '') !== (init.country_name ?? '') ||
            (userState ?? '') !== (init.state_name ?? '') ||
            (userZipCode ?? '') !== (init.zip ?? '') ||
            (userStreet ?? '') !== (init.street ?? '') ||
            (userNumber ?? '') !== (init.number ?? '') ||
            (companyName ?? '') !== (init.company_name ?? '') ||
            (userYearCreated ?? '') !== (init.company_created_year ?? '') ||
            (userCompanyWebsite ?? '') !== (init.company_website ?? '') ||
            (userAgentCode ?? '') !== (init.agent_key ?? '') ||
            (userWhatsapp ?? '') !== (init.social_whatsapp ?? '') ||
            (userSkype ?? '') !== (init.social_skype ?? '') ||
            (userFacebook ?? '') !== (init.social_facebook ?? '') ||
            (userInstagram ?? '') !== (init.social_instagram ?? '') ||
            (userTelegram ?? '') !== (init.social_telegram ?? '') ||
            (userLinkedIn ?? '') !== (init.social_linkedin ?? '')
        );
    }, [
        userFName, userLName, userEmail, userTitle, userGender, userLanguage, userPhone, userLicenceNumber,
        userSpokenLanguage, userShortIntroduction, userAboutMe, userCity, userCountry,
        userState, userZipCode, userStreet, userNumber, companyName, userYearCreated,
        userCompanyWebsite, userAgentCode, userWhatsapp, userSkype, userFacebook,
        userInstagram, userTelegram, userLinkedIn
    ]);

    const blocker = useBlocker(
        ({ currentLocation, nextLocation }) =>
            isDirty &&
            activeRightSection === 'details' &&
            currentLocation.pathname !== nextLocation.pathname
    );
    if (blocker.state === 'blocked') {
        leaveBlockerRef.current = blocker;
    }

    const handleLeaveConfirm = () => {
        if (isSavingOnLeave) return;
        setIsSavingOnLeave(true);
        updateProfile(
            () => {
                leaveBlockerRef.current?.proceed?.();
                setIsSavingOnLeave(false);
            },
            () => setIsSavingOnLeave(false)
        );
    };
    const handleLeaveCancel = () => {
        if (isSavingOnLeave) return;
        leaveBlockerRef.current?.proceed?.();
    };

    const handleLeaveConfirmReload = () => {
        if (isSavingOnLeave) return;
        setIsSavingOnLeave(true);
        updateProfile(
            () => {
                setIsSavingOnLeave(false);
                setShowLeaveModalForReload(false);
                window.location.reload();
            },
            () => setIsSavingOnLeave(false)
        );
    };
    const handleLeaveCancelReload = () => {
        if (isSavingOnLeave) return;
        setShowLeaveModalForReload(false);
    };

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (!isDirty || activeRightSection !== 'details') return;
            const isReload = e.key === 'F5' || (e.ctrlKey && e.key === 'r') || (e.metaKey && e.key === 'r');
            if (isReload) {
                e.preventDefault();
                setShowLeaveModalForReload(true);
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [isDirty, activeRightSection]);

    useEffect(() => {
        const handleGearClickOutside = (e) => {
            if (gearMenuRef.current && !gearMenuRef.current.contains(e.target)) {
                setGearMenuOpen(false);
            }
            if (webSettingsGearRef.current && !webSettingsGearRef.current.contains(e.target)) {
                setWebSettingsGearOpen(false);
            }
        };
        document.addEventListener('mousedown', handleGearClickOutside);
        return () => document.removeEventListener('mousedown', handleGearClickOutside);
    }, []);

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth <= 767);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    useEffect(() => {
        if (loading) return;
        const root = document.querySelector('.profile-details');
        if (!root) return;

        const onFocusIn = (e) => {
            const target = e.target;
            if (
                target instanceof HTMLElement &&
                (target.matches('.detail-input') ||
                    target.matches('.profile-password-input') ||
                    target.getAttribute('contenteditable') === 'true')
            ) {
                target.classList.add('editable');
            }
        };

        const onFocusOut = (e) => {
            const target = e.target;
            if (
                target instanceof HTMLElement &&
                (target.matches('.detail-input') ||
                    target.matches('.profile-password-input') ||
                    target.getAttribute('contenteditable') === 'true')
            ) {
                target.classList.remove('editable');
            }
        };

        root.addEventListener('focusin', onFocusIn);
        root.addEventListener('focusout', onFocusOut);
        return () => {
            root.removeEventListener('focusin', onFocusIn);
            root.removeEventListener('focusout', onFocusOut);
        };
    }, [loading]);

    const handleChangePasswordClick = () => navigate('/profile/change-password');
    const handleChangePasswordCancel = () => {
        setOldPassword('');
        setNewPassword('');
        setConfirmPassword('');
        navigate('/profile');
    };
    const handleChangePasswordSubmit = (e) => {
        e.preventDefault();
        // TODO: API call to change password; validate new === confirm
        handleChangePasswordCancel();
    };

    const handleChangeEmailClick = () => navigate('/profile/change-email');
    const handleChangeEmailCancel = () => {
        setOldEmail('');
        setNewEmail('');
        navigate('/profile');
    };
    const handleChangeEmailSubmit = (e) => {
        e.preventDefault();
        // TODO: API call to change email
        handleChangeEmailCancel();
    };
    const handleInfoClick = () => navigate('/profile');
    const handleWebSettingsClick = () => navigate('/profile/web-settings');
    const handleWebSettingsUpdate = () => {
        showNotification('Success', 'Web settings updated', 'success');
    };
    const handleOpenDefaultThemeModal = () => {
        if (!defaultThemeImages.length && userID) {
            fetchThemeImage(userID);
        }
        setDefaultThemeModalOpen(true);
    };
    const handleSelectDefaultThemeImage = (imageUrl) => {
        setSelectedThemeImage(imageUrl);
        setWebBannerImage(imageUrl);
        setDefaultThemeModalOpen(false);
    };
    const handleBannerImageUploadClick = () => {
        bannerImageInputRef.current?.click();
    };
    const handleBannerImageChange = (event) => {
        const file = event.target.files?.[0];
        if (!file) return;
        const allowedTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/jpg'];
        if (!allowedTypes.includes(file.type)) {
            showNotification('Error', 'Please select a JPG, JPEG, PNG, or WEBP image', 'danger');
            event.target.value = '';
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            const base64Image = reader.result;
            if (typeof base64Image !== 'string') {
                showNotification('Error', 'Unable to read selected image', 'danger');
                return;
            }
            setWebBannerImage(base64Image);
            setThemeImage('1', '', base64Image);
        };
        reader.readAsDataURL(file);
        event.target.value = '';
    };
    const handleFavIconUploadClick = () => {
        favIconInputRef.current?.click();
    };
    const handleFavIconChange = (event) => {
        const file = event.target.files?.[0];
        if (!file) return;
        const allowedTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/jpg', 'image/x-icon', 'image/vnd.microsoft.icon'];
        if (!allowedTypes.includes(file.type)) {
            showNotification('Error', 'Please select a valid icon/image file', 'danger');
            event.target.value = '';
            return;
        }
        const reader = new FileReader();
        reader.onloadend = () => {
            const base64Image = reader.result;
            if (typeof base64Image !== 'string') {
                showNotification('Error', 'Unable to read selected icon', 'danger');
                return;
            }
            setFavIconImageBase64(base64Image);
            setWebFavIcon(base64Image);
        };
        reader.readAsDataURL(file);
        event.target.value = '';
    };
    const handleMobileBackClick = () => {
        const section = profileSectionFromPath(location.pathname);
        if (section === 'change-password') return handleChangePasswordCancel();
        if (section === 'change-email') return handleChangeEmailCancel();
        if (section === 'web-settings') {
            navigate('/profile');
            return;
        }
        navigate('/home');
    };

    useEffect(() => {

        const userid = localStorage.getItem('user_id');
        setLoading(true);
        setUserID(userid);

        const memberID = location.state?.memberID;
        console.log(memberID);

        const connectionCount = localStorage.getItem('connection_count');
        setconnectionCount(connectionCount);
        const listingCount = localStorage.getItem('listing_count');
        setlistingCount(listingCount);
        const portfolioCount = localStorage.getItem('portfolio_count');
        setportfolioCount(portfolioCount);
        document.body.classList.add('profile-page');

        fetchCountryAPI();
        fetchDetailsUser(userid);
        fetchContant(userid);
        getDefaultLanguage();
        fetchThemeImage(userid);
        return () => {
            document.body.classList.remove('profile-page');
        };
    }, []);

    const handleLogoutClick = () => {
        setIsDropdownOpen(false);
        setIsLogoutModalOpen(true);
    };

    const handleLogoutConfirm = () => {
        localStorage.removeItem('user_id');
        // localStorage.removeItem('agentKey');
        setIsLogoutModalOpen(false);
        navigate('/');
    };

    const handleLogoutCancel = () => {
        setIsLogoutModalOpen(false);
    };
    const handleGearOptionClick = (action) => {
        setGearMenuOpen(false);
        if (action === 'logout') {
            handleLogoutClick();
        } else if (action === 'push-notification') {
            navigate('/notifications');
        } else if (action === 'change-password') {
            navigate('/profile/change-password');
        } else if (action === 'change-email') {
            navigate('/profile/change-email');
        } else if (action === 'share') {
            if (navigator.share) {
                navigator.share({
                    title: 'YesMLS Pro',
                    text: 'Check this out',
                    url: window.location.href
                }).catch(() => { });
            } else {
                showNotification('Info', 'Share is not supported in this browser', 'danger');
            }
        } else if (action === 'web-settings') {
            navigate('/profile/web-settings');
        }
    };

    function normalizeGenderFromApi(value) {
        if (value == null || value === '') return '';
        const v = String(value).trim().toLowerCase();
        const map = {
            '1': 'Male', '2': 'Female', '3': 'Other', '0': 'Prefer not to say',
            male: 'Male', female: 'Female', other: 'Other', 'prefer not to say': 'Prefer not to say'
        };
        return map[v] ?? String(value).trim();
    }

    function normalizeAppLanguageFromApi(value) {
        if (value == null || value === '') return '';
        const v = String(value).trim().toLowerCase();
        const map = {
            en: 'English', english: 'English',
            fr: 'Francais', french: 'Francais', francais: 'Francais',
            nl: 'Nederlands', dutch: 'Nederlands', nederlands: 'Nederlands',
            pt: 'Portugues', portuguese: 'Portugues', portugues: 'Portugues'
        };
        return map[v] ?? String(value).trim();
    }

    const GENDER_OPTIONS = [
        { value: '', label: 'Select Gender' },
        { value: 'Male', label: 'Male' },
        { value: 'Female', label: 'Female' },
        { value: 'Other', label: 'Other' },

    ];

    const LANGUAGE_OPTIONS = [
        { value: '', label: 'Select Language' },
        { value: 'English', label: 'English' },
        { value: 'French', label: 'Francais' },
        { value: 'Dutch', label: 'Nederlands' },
        // { value: 'Portuguese', label: 'Portugues' },
    ];

    const SPOKEN_LANGUAGE_OPTIONS = [
        { value: '', label: 'Select Spoken Language' },
        { value: 'English', label: 'English' },
        { value: 'Spanish', label: 'Spanish' },
        { value: 'French', label: 'French' },
        { value: 'German', label: 'German' },
        { value: 'Bengali', label: 'Bengali' },
        { value: 'Hindi', label: 'Hindi' },
        { value: 'Arabic', label: 'Arabic' },
        { value: 'Chinese', label: 'Chinese' },
        { value: 'Portuguese', label: 'Portuguese' },
        { value: 'Russian', label: 'Russian' },
    ];

    function fetchDetailsUser(userid) {
        // const { navigate } = this.props.navigation;
        let formdata = new FormData();
        formdata.append("user_id", userid)
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055")
        fetch(baseURL.URL + '/users/get_user_details', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                if (responseJson.server.result_code === 200) {
                    const result = responseJson.response
                    // localStorage.setItem('connection_count', result.connection_count)
                    // localStorage.setItem('listing_count', result.listing_count)
                    // localStorage.setItem('portfolio_count', result.portfolio_count)
                    setconnectionCount(result.connection_count)
                    setlistingCount(result.listing_count)
                    setportfolioCount(result.portfolio_count)
                    setUserFName(result.fname)
                    setUserLName(result.lname)
                    setUserEmail(result.email)
                    setUserPicture(result.picture)
                    setUserTitle(result.title)
                    setUserGender(normalizeGenderFromApi(result.gender))
                    setUserPhone(result.phone)
                    setUserLicenceNumber(result.licence_number)
                    setUserSpokenLanguage(result.spoken_languages ?? '')
                    setUserLanguage(normalizeAppLanguageFromApi(result.app_language))
                    setAppLanguageAndNotify(result.app_language)
                    setUserShortIntroduction(result.about_me)
                    setUserAboutMe(result.who_am_i)
                    setUserCity(result.city_name)
                    setUserCountry(result.country_name)
                    setUserCompanyImage(result.company_image_thumb)
                    setCompanyName(result.company_name)
                    setUserYearCreated(result.company_created_year)
                    setUserCompanyWebsite(result.company_website ?? result.company_name ?? '')
                    setUserAgentCode(result.agent_key)
                    setUserState(result.state_name)
                    setUserZipCode(result.zip ?? '')
                    setUserStreet(result.street ?? '')
                    setUserNumber(result.number ?? '')
                    setUserWhatsapp(result.social_whatsapp ?? '')
                    setUserSkype(result.social_skype ?? '')
                    setUserFacebook(result.social_facebook ?? '')
                    setUserInstagram(result.social_instagram ?? '')
                    setUserTelegram(result.social_telegram ?? '')
                    setUserLinkedIn(result.social_linkedin ?? '')

                    setUserStateId(result.state ?? '')
                    setUserCityId(result.city ?? '')
                    setUserCountryId(result.country ?? '')

                    initialProfileRef.current = {
                        fname: result.fname ?? '',
                        lname: result.lname ?? '',
                        email: result.email ?? '',
                        title: result.title ?? '',
                        gender: result.gender ?? '',
                        app_language: result.app_language ?? '',
                        phone: result.phone ?? '',
                        licence_number: result.licence_number ?? '',
                        spoken_languages: result.spoken_languages ?? '',
                        about_me: result.about_me ?? '',
                        who_am_i: result.who_am_i ?? '',
                        city_name: result.city_name ?? '',
                        country_name: result.country_name ?? '',
                        state_name: result.state_name ?? '',
                        state: result.state ?? '',
                        city: result.city ?? '',
                        country: result.country ?? '',
                        zip: result.zip ?? '',
                        street: result.street ?? '',
                        number: result.number ?? '',
                        company_name: result.company_name ?? '',
                        company_created_year: result.company_created_year ?? '',
                        company_website: (result.company_website ?? result.company_name) ?? '',
                        agent_key: result.agent_key ?? '',
                        social_whatsapp: result.social_whatsapp ?? '',
                        social_skype: result.social_skype ?? '',
                        social_facebook: result.social_facebook ?? '',
                        social_instagram: result.social_instagram ?? '',
                        social_telegram: result.social_telegram ?? '',
                        social_linkedin: result.social_linkedin ?? ''
                    };

                    if (result.state == '' || result.state == '0' || result.state == ' ' || result.country == '' || result.country == ' ') {
                        navigate('/info-details')
                        // this.setState({ isProfileComplete: false })
                    }
                    else {
                        console.log("$$$$$$$$$$$$$$test")
                        // this.setState({ isProfileComplete: true })
                    }
                    setLoading(false);
                }
                else {
                    setLoading(false);
                }
            })
            .catch((error) => {
                console.error(error);
                setLoading(false);
            });
    }

    function changePasswordApi() {
        if (oldPassword.length >= 6 && newPassword.length >= 6 && confirmPassword.length >= 6 && newPassword == confirmPassword) {
            let formdata = new FormData();
            formdata.append("user_id", userID)
            formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055")
            formdata.append("oldpassword", oldPassword)
            formdata.append("newpassword", newPassword)
            fetch(baseURL.URL + '/users/change_password', {
                method: 'POST',
                body: formdata
            }).then((response) => response.json())
                .then((responseJson) => {
                    //  console.log(responseJson.server.message);
                    const result = responseJson.response
                    if (responseJson.server.result_code === 200) {
                        showNotification(responseJson.server.message, 'success');
                        handleChangePasswordCancel();
                    }
                    else {
                        console.log(responseJson.server.result_code)
                        showNotification(responseJson.server.message, 'danger');
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    }

    function changeEmailApi(oldEmail, newEmail) {
        console.log(userID)

        if (newEmail != '' || newEmail != ' ') {
            let formdata = new FormData();

            formdata.append("user_id", userID)
            formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055")
            formdata.append("oldemail", oldEmail)
            formdata.append("newemail", newEmail)

            console.log(formdata);

            fetch(baseURL.URL + '/users/change_email', {
                method: 'POST',

                body: formdata

            }).then((response) => response.json())
                .then((responseJson) => {

                    //  console.log(responseJson.server.message);
                    const result = responseJson.response
                    console.log(responseJson);
                    if (responseJson.server.result_code === 200) {
                        //
                        navigate('/email-otp-check', { newEmail: newEmail })
                    }
                    else {
                        console.log(responseJson.server.result_code)
                        showNotification(responseJson.server.message, 'danger');
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }
        else {
            showNotification('Please enter a valid email', 'danger');
        }
    }


    function updateProfile(onSuccess, onError) {
        if (!userID) return;
        const shortIntroNew = (userShortIntroduction ?? '').replace(/[\r\n]+/g, '\n');
        const languageName = userLanguage == "Nederlands" ? "Dutch" : userLanguage == "Francais" ? "French" : userLanguage == "English" ? "English" : userLanguage;
        const formdata = new FormData();
        formdata.append("user_id", userID);
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055");
        formdata.append("title", userTitle ?? '');
        formdata.append("gender", userGender ?? '');
        formdata.append("app_language", languageName ?? '');
        // console.log(userLanguage);
        formdata.append("company_name", companyName ?? '');
        formdata.append("licence_number", userLicenceNumber ?? '');
        formdata.append("spoken_languages", userSpokenLanguage ?? '');
        formdata.append("fname", userFName ?? '');
        formdata.append("lname", userLName ?? '');
        formdata.append("email", userEmail ?? '');
        formdata.append("phone", userPhone ?? '');
        formdata.append("state", userStateId ?? '');
        formdata.append("city", userCityId ?? '');
        formdata.append("country", userCountryId ?? '');
        formdata.append("state_name", userState ?? '');
        formdata.append("city_name", userCity ?? '');
        formdata.append("country_name", userCountry ?? '');
        formdata.append("street", userStreet ?? '');
        formdata.append("nr", userNumber ?? '');
        formdata.append("zip", userZipCode ?? '');
        formdata.append("aboutme", shortIntroNew);
        formdata.append("who_am_i", userAboutMe ?? '');
        formdata.append("company_created_year", userYearCreated ?? '');
        formdata.append("social_skype", userSkype ?? '');
        formdata.append("social_whatsapp", userWhatsapp ?? '');
        formdata.append("social_telegram", userTelegram ?? '');
        formdata.append("social_linkedin", userLinkedIn ?? '');
        formdata.append("social_facebook", userFacebook ?? '');
        formdata.append("social_instagram", userInstagram ?? '');

        fetch(baseURL.URL + '/users/change', {
            method: 'POST',
            body: formdata
        })
            .then((response) => response.json())
            .then((responseJson) => {
                if (responseJson.server?.result_code === 200) {
                    initialProfileRef.current = {
                        fname: userFName ?? '',
                        lname: userLName ?? '',
                        email: userEmail ?? '',
                        title: userTitle ?? '',
                        gender: userGender ?? '',
                        app_language: userLanguage ?? '',
                        phone: userPhone ?? '',
                        licence_number: userLicenceNumber ?? '',
                        spoken_languages: userSpokenLanguage ?? '',
                        about_me: userShortIntroduction ?? '',
                        who_am_i: userAboutMe ?? '',
                        city_name: userCity ?? '',
                        country_name: userCountry ?? '',
                        state_name: userState ?? '',
                        state: userStateId ?? '',
                        city: userCityId ?? '',
                        country: userCountryId ?? '',
                        zip: userZipCode ?? '',
                        street: userStreet ?? '',
                        number: userNumber ?? '',
                        company_name: companyName ?? '',
                        company_created_year: userYearCreated ?? '',
                        company_website: userCompanyWebsite ?? '',
                        agent_key: userAgentCode ?? '',
                        social_whatsapp: userWhatsapp ?? '',
                        social_skype: userSkype ?? '',
                        social_facebook: userFacebook ?? '',
                        social_instagram: userInstagram ?? '',
                        social_telegram: userTelegram ?? '',
                        social_linkedin: userLinkedIn ?? ''
                    };
                    showNotification('Profile updated successfully', 'success');
                    setAppLanguageAndNotify(profileLanguageLabelToCode(userLanguage));
                    if (typeof onSuccess === 'function') onSuccess();
                } else {
                    showNotification(responseJson.server?.message || 'Failed to update profile', 'danger');
                    if (typeof onError === 'function') onError();
                }
            })
            .catch((error) => {
                console.error(error);
                showNotification('Failed to update profile', 'danger');
                if (typeof onError === 'function') onError();
            });
    }


    function updateProfileImage(imageBase64 = profileImageBase64) {
        // console.log(this.state.profileImageBase64)
        if (!imageBase64) {
            showNotification('Error', 'No image data found', 'danger');
            return;
        }
        setIsUploadingProfileImage(true);
        let formdata = new FormData();
        formdata.append("user_id", userID)
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055")
        formdata.append("profile_image", imageBase64)
        fetch(baseURL.URL + '/users/change_profile_pic', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                //  console.log(responseJson.server.message);
                const result = responseJson.response
                if (responseJson.server.code === 200) {
                    const apiImage = responseJson.response?.profile_image;
                    if (apiImage) {
                        // Persist for Header + other UI
                        localStorage.setItem('user_picture', apiImage);
                        // Cache-bust for immediate UI refresh
                        const imageWithTimestamp = apiImage + (apiImage.includes('?') ? '&' : '?') + 't=' + Date.now();
                        setUserPicture(imageWithTimestamp);
                        window.dispatchEvent(new Event('profileImageUpdated'));
                    }
                    fetchDetailsUser(userID);
                    showNotification('Success', 'Profile image updated successfully', 'success')
                }
                else {
                    //console.log(responseJson.server.code)
                    showNotification('Error', responseJson.server.message, 'danger')
                }
            })
            .catch((error) => {
                console.error(error);
                showNotification('Error', 'Failed to upload image', 'danger');
            })
            .finally(() => {
                setIsUploadingProfileImage(false);
            });
    }


    function updateCompanyImage(imageBase64 = companyImageBase64) {
        // console.log('company image')
        // console.log(this.state.companyImageBase64)
        if (!imageBase64) {
            showNotification('Error', 'No image data found', 'danger');
            return;
        }
        setIsUploadingCompanyImage(true);
        let formdata = new FormData();
        formdata.append("user_id", userID)
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055")
        formdata.append("company_image", imageBase64)
        fetch(baseURL.URL + '/users/change_company_pic', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                //  console.log(responseJson.server.message);
                const result = responseJson.response
                if (responseJson.server.code === 200) {
                    // this.props.navigation.goBack()
                    fetchDetailsUser(userID);
                    showNotification('Success', 'Company image updated successfully', 'success');
                }
                else {
                    console.log(responseJson.server.code)
                    showNotification('Error', responseJson.server.message, 'danger');
                    //  Alert.alert(responseJson.server.result_code)
                }
            })
            .catch((error) => {
                console.error(error);
                showNotification('Error', 'Failed to upload image', 'danger');
            })
            .finally(() => {
                setIsUploadingCompanyImage(false);
            });
    }

    const handleAvatarEditClick = (e) => {
        e.preventDefault();
        setCropTarget('profile');
        profileImageInputRef.current?.click();
    };

    const handleCompanyEditClick = (e) => {
        e.preventDefault();
        setCropTarget('company');
        companyImageInputRef.current?.click();
    };

    const handleProfileImageChange = (event) => {
        const file = event.target.files?.[0];
        if (!file) return;
        setCropTarget('profile');

        const allowedTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/jpg'];
        if (!allowedTypes.includes(file.type)) {
            showNotification('Error', 'Please select a JPG, JPEG, PNG, or WEBP image', 'danger');
            event.target.value = '';
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            const fullDataUrl = reader.result;
            if (typeof fullDataUrl !== 'string') {
                showNotification('Error', 'Unable to read the selected image', 'danger');
                return;
            }
            setCropperImageSrc(fullDataUrl);
            setIsCropperOpen(true);
            setCrop({ x: 0, y: 0 });
            setZoom(1);
        };
        reader.readAsDataURL(file);
        event.target.value = '';
    };

    const handleCompanyImageChange = (event) => {
        const file = event.target.files?.[0];
        if (!file) return;
        setCropTarget('company');

        const allowedTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/jpg'];
        if (!allowedTypes.includes(file.type)) {
            showNotification('Error', 'Please select a JPG, JPEG, PNG, or WEBP image', 'danger');
            event.target.value = '';
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            const fullDataUrl = reader.result;
            if (typeof fullDataUrl !== 'string') {
                showNotification('Error', 'Unable to read the selected image', 'danger');
                return;
            }
            setCropperImageSrc(fullDataUrl);
            setIsCropperOpen(true);
            setCrop({ x: 0, y: 0 });
            setZoom(1);
        };
        reader.readAsDataURL(file);
        event.target.value = '';
    };

    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);

    const handleCropSave = async () => {
        if (!croppedAreaPixels || !cropperImageSrc) return;
        if (isUploadingAnyImage) return;
        try {
            const croppedBase64 = await getCroppedImg(cropperImageSrc, croppedAreaPixels);
            setIsCropperOpen(false);
            if (cropTarget === 'company') {
                setCompanyImageBase64(croppedBase64);
                setUserCompanyImage(croppedBase64);
                updateCompanyImage(croppedBase64);
            } else {
                setProfileImageBase64(croppedBase64);
                setUserPicture(croppedBase64);
                updateProfileImage(croppedBase64);
            }
        } catch (error) {
            console.error('Error cropping image:', error);
            showNotification('Error', 'Failed to crop image', 'danger');
        }
    };

    const handleCropCancel = () => {
        if (isUploadingAnyImage) return;
        setIsCropperOpen(false);
        setCropperImageSrc('');
        setCrop({ x: 0, y: 0 });
        setZoom(1);
        setCroppedAreaPixels(null);
    };


    const normalizeList = (payload) => {
        if (Array.isArray(payload)) return payload;
        if (payload && typeof payload === 'object') return Object.values(payload);
        return [];
    };

    function fetchCountryAPI() {
        fetch(baseURL.URL + '/address/country', { method: 'POST' })
            .then((response) => response.json())
            .then((responseJson) => {
                setCountryList(responseJson.response?.countries || []);
            })
            .catch((error) => {
                console.error('Error fetching countries:', error);
                setCountryList([]);
            });
    }

    function fetchStateAPI(countryCode) {
        if (!countryCode) {
            setStateList([]);
            return;
        }
        const formdata = new FormData();
        formdata.append("country_code", countryCode);
        fetch(baseURL.URL + '/address/state', { method: 'POST', body: formdata })
            .then((response) => response.json())
            .then((responseJson) => {
                const statesPayload = responseJson.response?.states ?? responseJson.response?.regions ?? responseJson.response;
                setStateList(normalizeList(statesPayload));
            })
            .catch((error) => {
                console.error('Error fetching states:', error);
                setStateList([]);
            });
    }

    function fetchCityAPI(stateCode, countryCode) {
        if (!stateCode || !countryCode) {
            setCityList([]);
            return;
        }
        const formdata = new FormData();
        formdata.append("country_code", countryCode);
        formdata.append("state_id", stateCode);
        fetch(baseURL.URL + '/address/city', { method: 'POST', body: formdata })
            .then((response) => response.json())
            .then((responseJson) => {
                const citiesPayload = responseJson.response?.cities ?? responseJson.response;
                setCityList(normalizeList(citiesPayload));
            })
            .catch((error) => {
                console.error('Error fetching cities:', error);
                setCityList([]);
            });
    }

    useEffect(() => {
        if (userCountryId) {
            fetchStateAPI(userCountryId);
        } else {
            setStateList([]);
        }
    }, [userCountryId]);

    useEffect(() => {
        if (userCountryId && userStateId) {
            fetchCityAPI(userStateId, userCountryId);
        } else {
            setCityList([]);
        }
    }, [userCountryId, userStateId]);


    function fetchContant(userid) {
        console.log(userid)

        let formdata = new FormData();
        formdata.append("user_id", userid)
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055")
        fetch(baseURL.URL + '/users/fetch_premium_content', {
            method: 'POST',
            body: formdata

        }).then((response) => response.json())
            .then((responseJson) => {
                const result = responseJson.response
                console.log("FETCH Premium Content");
                console.log(result);
                if (responseJson.server.result_code === 200) {
                    console.log(result)

                    setBannerHeading(result.premium_content.banner_heading);
                    setBannerSubHeading(result.premium_content.banner_subheading);
                    setTbtDescription(result.premium_content.subheading);
                    setCardHeading(result.premium_content.heading);
                    setShowDefaultLanguage(result.premium_content.default_language);
                    setShowDefaultLanguageName(result.premium_content.default_language_name);
                    setSiteTitle(result.premium_content.site_title);
                    setSiteDescription(result.premium_content.site_description);
                    setWebFavIcon(result.premium_content.fav_icon);
                    // showNotification('Success', 'Web settings fetched successfully', 'success');
                }
                else {
                    console.log(responseJson.server.result_code)
                    showNotification('Error', responseJson.server.message, 'danger');
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }

    function getDefaultLanguage() {
        fetch('http://yesmls.com/yes100/api/users/fetch_default_language_list', {
            method: 'GET'
        })
            .then((response) => response.json())
            .then((responseJson) => {
                console.log(responseJson);
                setDefaultLanguage(responseJson.response.language_list);
            })
            .catch((error) => {
                console.error(error);
            });
    }

    function fetchThemeImage(userid) {
        console.log(userid)

        let formdata = new FormData();
        formdata.append("user_id", userid)
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055")
        fetch(baseURL.URL + '/users/fetch_premium_banner', {
            method: 'POST',
            body: formdata

        }).then((response) => response.json())
            .then((responseJson) => {
                const result = responseJson.response
                if (responseJson.server.result_code === 200) {
                    const defaultImages = Array.isArray(result?.default_images) ? result.default_images : [];
                    const selectedImage =
                        result?.user_selection?.selected_image ??
                        (Array.isArray(result?.user_selection) ? result.user_selection[0]?.selected_image : '') ??
                        '';
                    setDefaultThemeImages(defaultImages);
                    setSelectedThemeImage(selectedImage || '');
                    if (selectedImage) {
                        setWebBannerImage(selectedImage);
                    }
                    // showNotification('Success', 'Theme image fetched successfully', 'success');
                }
                else {
                    console.log(responseJson.server.result_code)
                    showNotification('Error', responseJson.server.message, 'danger');
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }

    function setThemeImage(uploadType, imageid, bannerImage) {
        if (!userID) return;

        let formdata = new FormData();
        formdata.append("user_id", userID)
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055")
        formdata.append("is_agent_upload", uploadType)
        formdata.append("banner_image", bannerImage)
        formdata.append("default_id", imageid)
        fetch(baseURL.URL + '/users/change_agent_banner', {
            method: 'POST',
            body: formdata

        }).then((response) => response.json())
            .then((responseJson) => {
                if (responseJson.server.result_code === 200) {
                    fetchThemeImage(userID);
                    showNotification('Success', responseJson.server.message, 'success');
                }
                else {
                    console.log(responseJson.server.result_code)
                    showNotification('Error', responseJson.server.message, 'danger');
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }

    function updateWebContent() {
        if (!userID) return;

        let formdata = new FormData();
        formdata.append("user_id", userID)
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055")
        formdata.append("banner_heading", webBannerHeading)
        formdata.append("banner_subheading", webBannerSubHeading)
        formdata.append("trust_subheading", webCardDescription)
        formdata.append("trust_heading", webCardHeading)
        formdata.append("site_title", webSiteTitle)
        formdata.append("site_description", webSiteDescription)
        formdata.append("default_language", webDefaultLanguage)
        formdata.append("favicon_img", favIconImageBase64)

        fetch(baseURL.URL + '/users/change_premium_content', {
            method: 'POST',
            body: formdata

        }).then((response) => response.json())
            .then((responseJson) => {
                if (responseJson.server.result_code === 200) {
                    fetchContant(userID);
                    fetchThemeImage(userID)
                    showNotification('Success', responseJson.server.message || 'Web settings updated', 'success');
                }
                else {
                    console.log(responseJson.server.result_code)
                    showNotification('Error', responseJson.server.message || 'Failed to update web settings', 'danger');
                }
            })
            .catch((error) => {
                console.error(error);
                showNotification('Error', error.message || 'Failed to update web settings', 'danger');
            });
    }


    if (loading) {
        return (
            <div className="content-right page-loader-wrapper">
                <div className="react-js-loader">
                    <div className="react-js-loader-spinner"></div>
                    <p className="react-js-loader-text">{stringsoflanguages.loading}</p>
                </div>
            </div>
        );
    }


    return (
        <>
            <ReactNotifications />
            <div className='profile-page'>
                <div className="container">
                    {isMobile && (
                        <div className="mobile-page-header">
                            <button className="mobile-back-btn" onClick={handleMobileBackClick} aria-label="Back">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                            <h2 className="mobile-page-title">{mobileHeaderTitle}</h2>
                        </div>
                    )}
                    <div className='profile-content'>
                        {/* Left Column - Profile Summary */}
                        {!isMobile || activeRightSection === 'details' ? (
                            <div className="profile-left">
                                <div className="profile-summary">
                                    <div className="profile-picture">
                                        <img src={userPicture} alt="Sumangal Basistha" />
                                        <button
                                            type="button"
                                            className="avatar-edit"
                                            id="desktopProfileEditBtn"
                                            aria-label="Edit Profile"
                                            onClick={handleAvatarEditClick}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <path d="M4.76 18.81C4.76 18.81 4.84 18.81 4.87 18.81L7.8 18.54C8.21 18.5 8.59 18.32 8.88 18.03L19.94 6.96998C20.46 6.44998 20.75 5.75998 20.75 5.02998C20.75 4.29998 20.46 3.60998 19.94 3.08998L19.23 2.37998C18.19 1.33998 16.38 1.33998 15.34 2.37998L13.93 3.78998L4.29 13.43C4 13.72 3.82 14.1 3.79 14.51L3.52 17.44C3.49 17.81 3.62 18.17 3.88 18.44C4.12 18.68 4.43 18.81 4.76 18.81ZM17.29 3.06998C17.61 3.06998 17.93 3.18998 18.17 3.43998L18.88 4.14998C19.12 4.38998 19.25 4.69998 19.25 5.02998C19.25 5.35998 19.12 5.67998 18.88 5.90998L18 6.78998L15.53 4.31998L16.41 3.43998C16.65 3.19998 16.97 3.06998 17.29 3.06998ZM5.28 14.65C5.28 14.59 5.31 14.54 5.35 14.5L14.46 5.37998L16.93 7.84998L7.82 16.96C7.82 16.96 7.72 17.03 7.67 17.03L5.04 17.27L5.28 14.64V14.65ZM22.75 22C22.75 22.41 22.41 22.75 22 22.75H2C1.59 22.75 1.25 22.41 1.25 22C1.25 21.59 1.59 21.25 2 21.25H22C22.41 21.25 22.75 21.59 22.75 22Z" fill="white" />
                                            </svg>
                                        </button>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            ref={profileImageInputRef}
                                            onChange={handleProfileImageChange}
                                            style={{ display: 'none' }}
                                        />

                                    </div>
                                    <div className="profile-name-section">
                                        <h2 className="profile-name">{userFName ?? ''} {userLName ?? ''}</h2>
                                        <p className="profile-handle">{userEmail}</p>
                                    </div>




                                    <div className="profile-stats">
                                        <div
                                            className="stat-item cursor-pointer"
                                            role="button"
                                            tabIndex={0}
                                            onClick={() => navigate('/home/my-listings', { state: profileStatsNavState })}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter' || e.key === ' ') {
                                                    e.preventDefault();
                                                    navigate('/home/my-listings', { state: profileStatsNavState });
                                                }
                                            }}
                                        >
                                            <div className="stat-number">{listingCount}</div>
                                            <div className="stat-label">{stringsoflanguages.listings}</div>
                                        </div>
                                        <div
                                            className="stat-item cursor-pointer"
                                            role="button"
                                            tabIndex={0}
                                            onClick={() => navigate('/home/my-connection', { state: profileStatsNavState })}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter' || e.key === ' ') {
                                                    e.preventDefault();
                                                    navigate('/home/my-connection', { state: profileStatsNavState });
                                                }
                                            }}
                                        >
                                            <div className="stat-number">{connectionCount}</div>
                                            <div className="stat-label">{stringsoflanguages.connections}</div>
                                        </div>
                                        <div
                                            className="stat-item cursor-pointer"
                                            role="button"
                                            tabIndex={0}
                                            onClick={() => navigate('/home/my-portfolio', { state: profileStatsNavState })}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter' || e.key === ' ') {
                                                    e.preventDefault();
                                                    navigate('/home/my-portfolio', { state: profileStatsNavState });
                                                }
                                            }}
                                        >
                                            <div className="stat-number">{portfolioCount}</div>
                                            <div className="stat-label">{stringsoflanguages.portfolio}</div>
                                        </div>
                                    </div>
                                    <div className="profile-nav">
                                        <div className="nav-item cursor-pointer" onClick={handleInfoClick}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                <path d="M10 1.66667C5.4 1.66667 1.66667 5.4 1.66667 10C1.66667 14.6 5.4 18.3333 10 18.3333C14.6 18.3333 18.3333 14.6 18.3333 10C18.3333 5.4 14.6 1.66667 10 1.66667ZM10 16.6667C6.325 16.6667 3.33333 13.675 3.33333 10C3.33333 6.325 6.325 3.33333 10 3.33333C13.675 3.33333 16.6667 6.325 16.6667 10C16.6667 13.675 13.675 16.6667 10 16.6667Z" fill="#000" />
                                                <path d="M10 5.83333V10.8333L13.3333 13.3333L14.1667 12.0833L11.6667 10V5.83333H10Z" fill="#000" />
                                            </svg>
                                            <span>{stringsoflanguages.info}</span>
                                        </div>
                                        <div className="nav-item cursor-pointer" onClick={handleChangePasswordClick}>
                                            <svg height="512" viewBox="0 0 56 56" width="512" xmlns="http://www.w3.org/2000/svg" id="fi_3257166"><g id="Page-1" fill="none" fill-rule="evenodd"><g id="010---Secure-Password" fill="rgb(0,0,0)" fill-rule="nonzero"><path id="Shape" d="m48 25c0-1.6568542-1.3431458-3-3-3h-34c-1.65685425 0-3 1.3431458-3 3v6h40zm-34 1h-2v2c0 .5522847-.4477153 1-1 1s-1-.4477153-1-1v-3c0-.5522847.4477153-1 1-1h3c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z"></path><path id="Shape" d="m8 53c0 1.6568542 1.34314575 3 3 3h34c1.6568542 0 3-1.3431458 3-3v-6h-40z"></path><path id="Shape" d="m55 33h-54c-.55228475 0-1 .4477153-1 1v10c0 .5522847.44771525 1 1 1h54c.5522847 0 1-.4477153 1-1v-10c0-.5522847-.4477153-1-1-1zm-45.445 7.168c.4595009.306518.583518.9274991.27699996 1.387-.30651803.4595009-.92749905.583518-1.38699996.277l-1.445-.964v1.132c0 .5522847-.44771525 1-1 1s-1-.4477153-1-1v-1.132l-1.445.964c-.45950091.306518-1.08048193.1825009-1.38699996-.277s-.18250092-1.080482.27699996-1.387l1.755-1.168-1.755-1.168c-.45950088-.306518-.58351799-.9274991-.27699996-1.387s.92749905-.583518 1.38699996-.277l1.445.964v-1.132c0-.5522847.44771525-1 1-1s1 .4477153 1 1v1.132l1.445-.964c.29724497-.1982824.67769307-.2229246.99803316-.0646441.3203401.1582805.53190491.4754371.55500002.832.02309512.3565629-.14578819.6983617-.44303318.8966441l-1.755 1.168zm11 0c.4595009.306518.583518.9274991.277 1.387-.3065181.4595009-.9274991.583518-1.387.277l-1.445-.964v1.132c0 .5522847-.4477153 1-1 1s-1-.4477153-1-1v-1.132l-1.445.964c-.4595009.306518-1.0804819.1825009-1.387-.277-.306518-.4595009-.1825009-1.080482.277-1.387l1.755-1.168-1.752-1.168c-.4595009-.306518-.583518-.9274991-.277-1.387.3065181-.4595009.9274991-.583518 1.387-.277l1.442.964v-1.132c0-.5522847.4477153-1 1-1s1 .4477153 1 1v1.132l1.445-.964c.297245-.1982824.6776931-.2229246.9980332-.0646441s.5319049.4754371.555.832-.1457882.6983617-.4430332.8966441l-1.755 1.168zm11 0c.4595009.3065181.583518.9274991.2769999 1.387-.306518.4595009-.927499.583518-1.3869999.277l-1.445-.964v1.132c0 .5522847-.4477153 1-1 1s-1-.4477153-1-1v-1.132l-1.445.964c-.4595009.306518-1.0804819.1825009-1.387-.277-.306518-.4595009-.1825009-1.080482.277-1.387l1.755-1.168-1.752-1.168c-.4595009-.3065181-.583518-.9274991-.2769999-1.387.306518-.4595009.927499-.583518 1.3869999-.277l1.442.964v-1.132c0-.5522847.4477153-1 1-1s1 .4477153 1 1v1.132l1.445-.964c.297245-.1982824.6776931-.2229246.9980332-.0646441.3203401.1582804.5319049.4754371.555.832s-.1457882.6983617-.4430332.8966441l-1.755 1.168zm11 0c.4595009.306518.583518.9274991.277 1.387-.3065181.4595009-.9274991.583518-1.387.277l-1.445-.964v1.132c0 .5522847-.4477153 1-1 1s-1-.4477153-1-1v-1.132l-1.445.964c-.4595009.306518-1.0804819.1825009-1.3869999-.277-.3065181-.4595009-.182501-1.0804819.2769999-1.387l1.755-1.168-1.752-1.168c-.4595009-.306518-.583518-.9274991-.277-1.387.3065181-.4595009.9274991-.583518 1.387-.277l1.442.964v-1.132c0-.5522847.4477153-1 1-1s1 .4477153 1 1v1.132l1.445-.964c.297245-.1982824.6776931-.2229246.9980332-.0646441.32034.1582805.5319049.4754371.555.832s-.1457882.6983617-.4430332.8966441l-1.755 1.168zm10.445 2.832h-6c-.5522847 0-1-.4477153-1-1s.4477153-1 1-1h6c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z"></path><path id="Shape" d="m17 15c0-6.07513225 4.9248678-11 11-11s11 4.92486775 11 11v5h4v-5c0-8.28427125-6.7157288-15-15-15s-15 6.71572875-15 15v5h4z"></path></g></g></svg>
                                            <span>{stringsoflanguages.changePassword}</span>
                                        </div>
                                        <div className="nav-item cursor-pointer" onClick={handleChangeEmailClick}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                <path d="M3.33333 3.33333H16.6667C17.5833 3.33333 18.3333 4.08333 18.3333 5V15C18.3333 15.9167 17.5833 16.6667 16.6667 16.6667H3.33333C2.41667 16.6667 1.66667 15.9167 1.66667 15V5C1.66667 4.08333 2.41667 3.33333 3.33333 3.33333ZM3.33333 5L10 9.16667L16.6667 5H3.33333ZM16.6667 15V6.66667L10 10.8333L3.33333 6.66667V15H16.6667Z" fill="#000" />
                                            </svg>
                                            <span>{stringsoflanguages.changeEmailId}</span>
                                        </div>
                                        <div className="nav-item cursor-pointer" onClick={() => handleGearOptionClick('share')}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                <path d="M15 10.8333V15.8333C15 16.75 14.25 17.5 13.3333 17.5H4.16667C3.25 17.5 2.5 16.75 2.5 15.8333V6.66667C2.5 5.75 3.25 5 4.16667 5H9.16667" stroke="#000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M12.5 2.5H17.5V7.5" stroke="#000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M8.33333 11.6667L17.5 2.5" stroke="#000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                            <span>{stringsoflanguages.share}</span>
                                        </div>
                                        <div className="nav-item cursor-pointer" onClick={handleWebSettingsClick}>
                                            <svg clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" id="fi_13446270"><g transform="translate(-96 -96)"><path d="m98.586 118.715c-1.015-2.02-1.586-4.302-1.586-6.715s.571-4.695 1.586-6.715c2.465-4.912 7.549-8.285 13.414-8.285s10.949 3.373 13.414 8.285c1.015 2.02 1.586 4.302 1.586 6.715s-.571 4.695-1.586 6.715c-2.465 4.912-7.549 8.285-13.414 8.285s-10.949-3.373-13.414-8.285zm1.4-11.688c-.635 1.532-.986 3.212-.986 4.973s.351 3.441.986 4.973c1.633-.633 3.558-1.141 5.683-1.483-.11-1.118-.169-2.287-.169-3.49s.059-2.372.169-3.49c-2.125-.342-4.05-.85-5.683-1.483zm23.115-1.791c-1.655-2.709-4.273-4.765-7.376-5.693.139.216.274.445.404.687.853 1.593 1.535 3.769 1.945 6.298 1.868-.303 3.569-.744 5.027-1.292zm-14.826-5.693c-3.103.928-5.721 2.984-7.376 5.693 1.458.549 3.159.989 5.027 1.292.41-2.529 1.092-4.705 1.945-6.298.13-.242.265-.471.404-.687zm15.739 17.43c.635-1.532.986-3.212.986-4.973s-.351-3.441-.986-4.973c-1.633.633-3.558 1.141-5.683 1.483.11 1.118.169 2.287.169 3.49s-.059 2.372-.169 3.49c2.125.342 4.05.85 5.683 1.483zm-23.115 1.791c1.655 2.709 4.273 4.765 7.376 5.693-.139-.216-.274-.445-.404-.687-.853-1.593-1.535-3.769-1.945-6.298-1.868.303-3.569.744-5.027 1.292zm14.826 5.693c3.103-.928 5.721-2.984 7.376-5.693-1.458-.548-3.159-.989-5.027-1.292-.41 2.529-1.092 4.705-1.945 6.298-.13.242-.265.471-.404.687zm-3.725-25.457c-.385 0-.745.183-1.091.477-.464.394-.888.975-1.275 1.698-.764 1.426-1.364 3.365-1.73 5.616 1.31.137 2.682.209 4.096.209s2.786-.073 4.096-.209c-.366-2.251-.966-4.19-1.73-5.616-.387-.723-.811-1.304-1.275-1.698-.346-.294-.706-.477-1.091-.477zm0 26c.385 0 .745-.183 1.091-.477.464-.394.888-.975 1.275-1.698.764-1.426 1.364-3.365 1.73-5.616-1.31-.136-2.682-.209-4.096-.209s-2.786.073-4.096.209c.366 2.251.966 4.19 1.73 5.616.387.723.811 1.304 1.275 1.698.346.294.706.477 1.091.477zm4.35-9.773c.098-1.034.15-2.115.15-3.227s-.052-2.193-.15-3.227c-1.391.148-2.849.227-4.35.227s-2.959-.079-4.35-.227c-.098 1.034-.15 2.115-.15 3.227s.052 2.193.15 3.227c1.391-.148 2.849-.227 4.35-.227s2.959.079 4.35.227z"></path></g></svg>
                                            <span>{stringsoflanguages.Website}</span>
                                        </div>
                                        {/* <div className="nav-item">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M7.5 2.5H4.16667C3.25 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.25 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V12.5" stroke="#000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M13.3333 2.5H17.5V6.66667" stroke="#000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M10.8333 9.16667L17.5 2.5" stroke="#000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                        <span>Terms & Conditions</span>
                                    </div> */}
                                        <div className="nav-item" onClick={handleLogoutClick}>
                                            <svg id="fi_2529508" height="512" viewBox="0 0 6.3499999 6.3500002" width="512" fill='#000' ><g id="layer1" transform="translate(0 -290.65)"><path id="path52" d="m3.1721577 291.17917a.26463566.26580324 0 0 0 -.262025.26889v2.12674a.26486756.26603617 0 0 0 .5297351 0v-2.12674a.26463566.26580324 0 0 0 -.2677101-.26889zm1.5437259.53311a.26463566.26580324 0 0 0 -.025842.00052.26463566.26580324 0 0 0 -.1467753.46926c.4583643.39096.7483457.97287.7483479 1.62632.0000018 1.17989-.9432648 2.13089-2.1153231 2.13089-1.1720581 0-2.1173921-.951-2.1173901-2.13089.000002-.64967.2862991-1.22762.7400788-1.61853a.26467261.26584036 0 1 0 -.343681-.40438c-.5664588.48798-.92612958 1.21533-.92613207 2.02291-.00000238 1.46669 1.18858337 2.66244 2.64712517 2.66244 1.4585422 0 2.6445438-1.19575 2.6445414-2.66244-.0000027-.81229-.3632264-1.54263-.9354347-2.03069a.26463566.26580324 0 0 0 -.1695153-.0654z" font-variant-ligatures="normal" font-variant-position="normal" font-variant-caps="normal" font-variant-numeric="normal" font-variant-alternates="normal" font-feature-settings="normal" text-indent="0" text-align="start" text-decoration-line="none" text-decoration-style="solid" text-decoration-color="rgb(0,0,0)" text-transform="none" text-orientation="mixed" white-space="normal" shape-padding="0" isolation="auto" mix-blend-mode="normal" solid-color="rgb(0,0,0)" solid-opacity="1" vector-effect="none"></path></g></svg>
                                            <span>{stringsoflanguages.logOut}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : null}

                        {/* Right Column - Profile Details */}
                        <div className="profile-right">
                            {/* {isMobile && activeRightSection !== 'details' && (
                                <div className="profile-mobile-subsection-back">
                                    <button
                                        type="button"
                                        className="profile-mobile-subsection-back-btn"
                                        onClick={handleMobileBackClick}
                                        aria-label="Back to profile"
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
                                            <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                        Back to profile
                                    </button>
                                </div>
                            )} */}
                            <div className="profile-details">
                                {activeRightSection === 'change-password' ? (
                                    <>
                                        <h3 className="section-title">{stringsoflanguages.changePassword}</h3>
                                        <form onSubmit={handleChangePasswordSubmit} className="detail-section">
                                            <div className="detail-content">
                                                <div className="detail-row">
                                                    <label className="detail-label">Old Password</label>
                                                    <input
                                                        type="password"
                                                        className="detail-value profile-password-input"
                                                        value={oldPassword}
                                                        onChange={(e) => setOldPassword(e.target.value)}
                                                        placeholder="Enter old password"
                                                    />
                                                </div>
                                                <div className="detail-row">
                                                    <label className="detail-label">{stringsoflanguages.newPassword}</label>
                                                    <input
                                                        type="password"
                                                        className="detail-value profile-password-input"
                                                        value={newPassword}
                                                        onChange={(e) => setNewPassword(e.target.value)}
                                                        placeholder="Enter new password"
                                                    />
                                                </div>
                                                <div className="detail-row">
                                                    <label className="detail-label">{stringsoflanguages.confirmPassword}</label>
                                                    <input
                                                        type="password"
                                                        className="detail-value profile-password-input"
                                                        value={confirmPassword}
                                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                                        placeholder="Confirm new password"
                                                    />
                                                </div>
                                            </div>
                                            <div className="profile-form-actions">
                                                <button type="button" className="cancel-btn custom-btn" onClick={handleChangePasswordCancel}>{stringsoflanguages.cancel}</button>
                                                <button type="submit" className="save-btn custom-btn" onClick={() => changePasswordApi()}>{stringsoflanguages.submit}</button>
                                            </div>
                                        </form>
                                    </>
                                ) : activeRightSection === 'change-email' ? (
                                    <>
                                        <h3 className="section-title">{stringsoflanguages.changeEmailId}</h3>
                                        <form onSubmit={handleChangeEmailSubmit} className="detail-section">
                                            <div className="detail-content change-email-content">
                                                <div className="detail-row">
                                                    <label className="detail-label">{stringsoflanguages.oldEmail}</label>
                                                    <input
                                                        type="email"
                                                        className="detail-value profile-password-input"
                                                        value={oldEmail}
                                                        onChange={(e) => setOldEmail(e.target.value)}
                                                        placeholder="Enter current email"
                                                    />
                                                </div>
                                                <div className="detail-row">
                                                    <label className="detail-label">{stringsoflanguages.newEmail}</label>
                                                    <input
                                                        type="email"
                                                        className="detail-value profile-password-input"
                                                        value={newEmail}
                                                        onChange={(e) => setNewEmail(e.target.value)}
                                                        placeholder="Enter new email"
                                                    />
                                                </div>
                                            </div>
                                            <div className="profile-form-actions">
                                                <button type="button" className="cancel-btn custom-btn" onClick={handleChangeEmailCancel}>{stringsoflanguages.cancel}</button>
                                                <button type="submit" className="save-btn custom-btn" onClick={() => changeEmailApi(oldEmail, newEmail)}>{stringsoflanguages.submit}</button>
                                            </div>
                                        </form>
                                    </>
                                ) : activeRightSection === 'web-settings' ? (
                                    <>
                                        <div className="web-settings-title-row">
                                            <h3 className="section-title">{stringsoflanguages.webSettings}</h3>
                                            {!isMobile && (
                                                <div className="btn-section btn-section-gear web-settings-gear-wrapper" ref={webSettingsGearRef}>
                                                    <button
                                                        type="button"
                                                        className={`btn-primary gear-btn ${webSettingsGearSpinning ? 'gear-spin' : ''}`}
                                                        onClick={() => {
                                                            setWebSettingsGearOpen((prev) => !prev);
                                                            setWebSettingsGearSpinning(true);
                                                            setTimeout(() => setWebSettingsGearSpinning(false), 500);
                                                        }}
                                                        aria-label="Web settings options"
                                                        aria-expanded={webSettingsGearOpen}
                                                    >
                                                        <i className="fa-solid fa-gear"></i>
                                                    </button>
                                                    {webSettingsGearOpen && (
                                                        <ul className="gear-dropdown" aria-label="Web settings options list">
                                                            <li>
                                                                <button
                                                                    type="button"
                                                                    className="gear-dropdown-item"
                                                                    onClick={() => {
                                                                        setWebSettingsGearOpen(false);
                                                                        const agentCode = String(userAgentCode ?? '').trim();
                                                                        if (!agentCode) {
                                                                            showNotification('Error', 'Agent code is missing', 'danger');
                                                                            return;
                                                                        }
                                                                        window.open(`http://yesmlspremium.com/${agentCode}`, '_blank', 'noopener,noreferrer');
                                                                    }}
                                                                >
                                                                    <i className="fa-solid fa-link"></i>
                                                                    <span>{stringsoflanguages.weblink}</span>
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                        <div className="detail-section web-settings-section">
                                            <div className="detail-content">
                                                <div className="detail-row banner-image-row">
                                                    <label className="detail-label">{stringsoflanguages.currentBannerImage}</label>

                                                    <div className='banner-image-section'>
                                                        <img src={webBannerImage} alt="Current banner" className="web-settings-banner-preview" />
                                                    </div>

                                                    <div className="web-settings-btn-row flex gap-2">
                                                        <button type="button" className="save-btn custom-btn" onClick={handleOpenDefaultThemeModal}>{stringsoflanguages.fromDefaultTheme}</button>
                                                        <button type="button" className="save-btn custom-btn" onClick={handleBannerImageUploadClick}>{stringsoflanguages.uploadYourImage}</button>
                                                        <input
                                                            type="file"
                                                            accept="image/*"
                                                            ref={bannerImageInputRef}
                                                            onChange={handleBannerImageChange}
                                                            style={{ display: 'none' }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="detail-row">
                                                    <label className="detail-label">{stringsoflanguages.bannerHeading}</label>
                                                    <input type="text" className="detail-value detail-input" value={webBannerHeading} onChange={(e) => setWebBannerHeading(e.target.value)} />
                                                </div>
                                                <div className="detail-section flex flex-col detail-row">
                                                    <label className="text-sm text-gray-600 font-medium">{stringsoflanguages.bannerSubHeading}</label>
                                                    <div
                                                        className="detail-text detail-input"
                                                        contentEditable
                                                        suppressContentEditableWarning
                                                        onInput={(e) => setWebBannerSubHeading(e.currentTarget.innerText)}
                                                    >
                                                        {webBannerSubHeading || '—'}
                                                    </div>
                                                </div>
                                                <div className="detail-row">
                                                    <label className="detail-label">{stringsoflanguages.cardHeading}</label>
                                                    <input type="text" className="detail-value detail-input" value={webCardHeading} onChange={(e) => setWebCardHeading(e.target.value)} />
                                                </div>
                                                <div className="detail-section flex flex-col detail-row">
                                                    <label className="text-sm text-gray-600 font-medium">{stringsoflanguages.cardDescription}</label>
                                                    <div
                                                        className="detail-text detail-input"
                                                        contentEditable
                                                        suppressContentEditableWarning
                                                        onInput={(e) => setWebCardDescription(e.currentTarget.innerText)}
                                                    >
                                                        {webCardDescription || '—'}
                                                    </div>
                                                </div>
                                                <div className="detail-row">
                                                    <label className="detail-label">{stringsoflanguages.siteTitle}</label>
                                                    <input type="text" className="detail-value detail-input" value={webSiteTitle} onChange={(e) => setWebSiteTitle(e.target.value)} />
                                                </div>
                                                <div className="detail-row">
                                                    <label className="detail-label">{stringsoflanguages.siteDescription}</label>
                                                    <textarea className="detail-value detail-input web-settings-textarea" value={webSiteDescription} onChange={(e) => setWebSiteDescription(e.target.value)} />
                                                </div>
                                                <div className="detail-row fav-icon-row">
                                                    <label className="detail-label">{stringsoflanguages.siteFavIcon}</label>
                                                    <button type="button" className="save-btn custom-btn w-full max-w-[150px]" onClick={handleFavIconUploadClick}>Upload Icon</button>
                                                    <input
                                                        type="file"
                                                        accept="image/*,.ico"
                                                        ref={favIconInputRef}
                                                        onChange={handleFavIconChange}
                                                        style={{ display: 'none' }}
                                                    />
                                                    {(webFavIcon || favIconImageBase64) && (
                                                        <div className="web-fav-icon-preview-wrap">
                                                            <img
                                                                src={favIconImageBase64 || webFavIcon}
                                                                alt="Fav icon preview"
                                                                className="web-fav-icon-preview"
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="detail-row">
                                                    <label className="detail-label">{stringsoflanguages.defaultLang}</label>
                                                    <input type="text" className="detail-value detail-input" value={webDefaultLanguage} onChange={(e) => setWebDefaultLanguage(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="profile-form-actions">
                                                <button type="button" className="save-btn custom-btn w-full max-w-[150px]" onClick={updateWebContent}>{stringsoflanguages.update}</button>
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className='detail-section apply-language-section'>
                                            <h3 className="section-title">{stringsoflanguages.chooseLanguage}</h3>
                                            <div className="detail-row">

                                                <select
                                                    className="detail-value detail-input"
                                                    value={userLanguage ?? ''}
                                                    onChange={(e) => setUserLanguage(e.target.value)}
                                                    aria-label="Language"
                                                >
                                                    {LANGUAGE_OPTIONS.map((opt) => (
                                                        <option key={opt.value || 'empty'} value={opt.value}>{opt.label}</option>
                                                    ))}
                                                    {userLanguage && !LANGUAGE_OPTIONS.some((o) => o.value === userLanguage) && (
                                                        <option value={userLanguage}>{userLanguage}</option>
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="detail-section">
                                            <h3 className="section-title">{stringsoflanguages.personalDetails}</h3>
                                            <div className="detail-content">

                                                <div className="detail-row">
                                                    <label className="detail-label">{stringsoflanguages.fName}</label>
                                                    <input type="text" className="detail-value detail-input" value={userFName ?? ''} onChange={(e) => setUserFName(e.target.value)} placeholder="First name" />
                                                </div>
                                                <div className="detail-row">
                                                    <label className="detail-label">{stringsoflanguages.lName}</label>
                                                    <input type="text" className="detail-value detail-input" value={userLName ?? ''} onChange={(e) => setUserLName(e.target.value)} placeholder="Last name" />
                                                </div>
                                                <div className="detail-row">
                                                    <label className="detail-label">{stringsoflanguages.titleFunction}</label>
                                                    <input type="text" className="detail-value detail-input" value={userTitle ?? ''} onChange={(e) => setUserTitle(e.target.value)} placeholder="Title" />
                                                </div>
                                                <div className="detail-row">
                                                    <label className="detail-label">{stringsoflanguages.gender}</label>
                                                    <select
                                                        className="detail-value detail-input"
                                                        value={userGender ?? ''}
                                                        onChange={(e) => setUserGender(e.target.value)}
                                                        aria-label="Gender"
                                                    >
                                                        {GENDER_OPTIONS.map((opt) => (
                                                            <option key={opt.value || 'empty'} value={opt.value}>{opt.label}</option>
                                                        ))}
                                                        {userGender && !GENDER_OPTIONS.some((o) => o.value === userGender) && (
                                                            <option value={userGender}>{userGender}</option>
                                                        )}
                                                    </select>
                                                </div>
                                                <div className="detail-row">
                                                    <label className="detail-label">{stringsoflanguages.licenceNumberCertification}</label>
                                                    <input type="text" className="detail-value detail-input" value={userLicenceNumber ?? ''} onChange={(e) => setUserLicenceNumber(e.target.value)} placeholder="Licence number" />
                                                </div>


                                            </div>
                                        </div>

                                        <div className="detail-section">
                                            <h3 className="section-title">{stringsoflanguages.contactDetails}</h3>
                                            <div className="detail-content">
                                                <div className="detail-row">
                                                    <label className="detail-label">{stringsoflanguages.spokenLanguage}</label>
                                                    <input
                                                        type="text"
                                                        className="detail-value detail-input"
                                                        value={userSpokenLanguage ?? ''}
                                                        onChange={(e) => setUserSpokenLanguage(e.target.value)}
                                                        aria-label="Spoken Language"
                                                    />
                                                </div>
                                                <div className="detail-row">
                                                    <label className="detail-label">{stringsoflanguages.phoneNo}</label>
                                                    <input type="text" className="detail-value detail-input" value={userPhone ?? ''} onChange={(e) => setUserPhone(e.target.value)} placeholder="Phone" />
                                                </div>
                                                <div className="detail-row email-locked-row">
                                                    <label className="detail-label">{stringsoflanguages.emailId}</label>
                                                    <div
                                                        title="You can not edit email address"
                                                        onClick={() => setShowEmailLockedModal(true)}
                                                        role="button"
                                                        tabIndex={0}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter' || e.key === ' ') {
                                                                e.preventDefault();
                                                                setShowEmailLockedModal(true);
                                                            }
                                                        }}
                                                        style={{ cursor: 'not-allowed' }}
                                                    >
                                                        <input
                                                            type="email"
                                                            className="detail-value detail-input"
                                                            value={userEmail ?? ''}
                                                            onChange={(e) => setUserEmail(e.target.value)}
                                                            placeholder="Email"
                                                            disabled
                                                            style={{ pointerEvents: 'none' }}
                                                        />
                                                    </div>
                                                </div>


                                            </div>
                                        </div>

                                        <div className="detail-section flex flex-col detail-row">
                                            <label className="text-sm text-gray-600 font-medium">{stringsoflanguages.shortIntroduction}</label>
                                            <div
                                                className="detail-text detail-input"
                                                contentEditable
                                                suppressContentEditableWarning
                                                onInput={(e) => setUserShortIntroduction(e.currentTarget.innerText)}
                                            >
                                                {userShortIntroduction || '—'}
                                            </div>
                                        </div>

                                        <div className="detail-section flex flex-col detail-row">
                                            <label className="text-sm text-gray-600 font-medium">{stringsoflanguages.aboutMe}</label>
                                            <div
                                                className="detail-text detail-input"
                                                contentEditable
                                                suppressContentEditableWarning
                                                onInput={(e) => setUserAboutMe(e.currentTarget.innerText)}
                                            >
                                                {userAboutMe || '—'}
                                            </div>
                                        </div>

                                        <div className="detail-section">
                                            <h3 className="section-title">{stringsoflanguages.companyInformation}</h3>
                                            <div className='detail-row company-image-section'>
                                                <div className="profile-picture company-image-sec">
                                                    <img src={userCompanyImage} alt='Company Image' />
                                                    <button
                                                        type="button"
                                                        className="avatar-edit"
                                                        id="desktopProfileEditBtn"
                                                        aria-label="Edit Profile"
                                                        onClick={handleCompanyEditClick}
                                                    >
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                            <path d="M4.76 18.81C4.76 18.81 4.84 18.81 4.87 18.81L7.8 18.54C8.21 18.5 8.59 18.32 8.88 18.03L19.94 6.96998C20.46 6.44998 20.75 5.75998 20.75 5.02998C20.75 4.29998 20.46 3.60998 19.94 3.08998L19.23 2.37998C18.19 1.33998 16.38 1.33998 15.34 2.37998L13.93 3.78998L4.29 13.43C4 13.72 3.82 14.1 3.79 14.51L3.52 17.44C3.49 17.81 3.62 18.17 3.88 18.44C4.12 18.68 4.43 18.81 4.76 18.81ZM17.29 3.06998C17.61 3.06998 17.93 3.18998 18.17 3.43998L18.88 4.14998C19.12 4.38998 19.25 4.69998 19.25 5.02998C19.25 5.35998 19.12 5.67998 18.88 5.90998L18 6.78998L15.53 4.31998L16.41 3.43998C16.65 3.19998 16.97 3.06998 17.29 3.06998ZM5.28 14.65C5.28 14.59 5.31 14.54 5.35 14.5L14.46 5.37998L16.93 7.84998L7.82 16.96C7.82 16.96 7.72 17.03 7.67 17.03L5.04 17.27L5.28 14.64V14.65ZM22.75 22C22.75 22.41 22.41 22.75 22 22.75H2C1.59 22.75 1.25 22.41 1.25 22C1.25 21.59 1.59 21.25 2 21.25H22C22.41 21.25 22.75 21.59 22.75 22Z" fill="white" />
                                                        </svg>
                                                    </button>
                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        ref={companyImageInputRef}
                                                        onChange={handleCompanyImageChange}
                                                        style={{ display: 'none' }}
                                                    />

                                                </div>
                                            </div>
                                            <div className="detail-content">

                                                <div className="detail-row">
                                                    <label className="detail-label">{stringsoflanguages.companyName}</label>
                                                    <input type="text" className="detail-value detail-input" value={companyName ?? ''} onChange={(e) => setCompanyName(e.target.value)} placeholder="Company name" />
                                                </div>
                                                <div className="detail-row">
                                                    <label className="detail-label">{stringsoflanguages.yearCreated}</label>
                                                    <input type="text" className="detail-value detail-input" value={userYearCreated ?? ''} onChange={(e) => setUserYearCreated(e.target.value)} placeholder="Year" />
                                                </div>
                                                <div className="detail-row">
                                                    <label className="detail-label">{stringsoflanguages.companyWebsite}</label>
                                                    <input type="text" className="detail-value detail-input" value={userCompanyWebsite ?? ''} onChange={(e) => setUserCompanyWebsite(e.target.value)} placeholder="Website" />
                                                </div>
                                                <div className="detail-row">
                                                    <label className="detail-label">{stringsoflanguages.agentCode}</label>
                                                    <input type="text" className="detail-value detail-input" value={userAgentCode ?? ''} onChange={(e) => setUserAgentCode(e.target.value)} placeholder="Agent code" />
                                                </div>
                                                <div className="detail-row">
                                                    <label className="detail-label">{stringsoflanguages.country}</label>
                                                    <select
                                                        className="detail-value detail-input"
                                                        value={userCountryId ?? ''}
                                                        onChange={(e) => {
                                                            const code = e.target.value;
                                                            setUserCountryId(code);
                                                            const item = countryList.find((c) => (c.code ?? c.id ?? '') === code);
                                                            setUserCountry(item ? (item.name ?? item.country_name ?? '') : '');
                                                            setUserStateId('');
                                                            setUserState('');
                                                            setUserCityId('');
                                                            setUserCity('');
                                                            setStateList([]);
                                                            setCityList([]);
                                                            if (code) fetchStateAPI(code);
                                                        }}
                                                        aria-label="Country"
                                                    >
                                                        <option value="">Select Country</option>
                                                        {countryList.map((c) => (
                                                            <option key={c.code ?? c.id ?? c.name} value={c.code ?? c.id ?? ''}>
                                                                {c.name ?? c.country_name ?? ''}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="detail-row">
                                                    <label className="detail-label">{stringsoflanguages.state}</label>
                                                    <select
                                                        className="detail-value detail-input"
                                                        value={userStateId ?? ''}
                                                        onChange={(e) => {
                                                            const code = e.target.value;
                                                            setUserStateId(code);
                                                            const item = stateList.find((s) => (s.region_code ?? s.state_id ?? s.id ?? '') === code);
                                                            setUserState(item ? (item.region_name ?? item.state_name ?? item.name ?? '') : '');
                                                            setUserCityId('');
                                                            setUserCity('');
                                                            setCityList([]);
                                                            if (code && userCountryId) fetchCityAPI(code, userCountryId);
                                                        }}
                                                        disabled={!userCountryId}
                                                        aria-label="State"
                                                    >
                                                        <option value="">Select State</option>
                                                        {stateList.map((s) => (
                                                            <option key={s.region_code ?? s.state_id ?? s.id ?? s.region_name} value={s.region_code ?? s.state_id ?? s.id ?? ''}>
                                                                {s.region_name ?? s.state_name ?? s.name ?? ''}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="detail-row">
                                                    <label className="detail-label">{stringsoflanguages.city}</label>
                                                    <select
                                                        className="detail-value detail-input"
                                                        value={userCityId ?? ''}
                                                        onChange={(e) => {
                                                            const code = e.target.value;
                                                            setUserCityId(code);
                                                            const item = cityList.find((c) => (c.city_id ?? c.id ?? '') === code);
                                                            setUserCity(item ? (item.city_name ?? item.name ?? '') : '');
                                                        }}
                                                        disabled={!userStateId}
                                                        aria-label="City"
                                                    >
                                                        <option value="">Select City</option>
                                                        {cityList.map((c) => (
                                                            <option key={c.city_id ?? c.id ?? c.city_name} value={c.city_id ?? c.id ?? ''}>
                                                                {c.city_name ?? c.name ?? ''}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="detail-row">
                                                    <label className="detail-label">{stringsoflanguages.zipCode}</label>
                                                    <input type="text" className="detail-value detail-input" value={userZipCode ?? ''} onChange={(e) => setUserZipCode(e.target.value)} placeholder="Zip code" />
                                                </div>
                                                <div className="detail-row">
                                                    <label className="detail-label">{stringsoflanguages.street}</label>
                                                    <input type="text" className="detail-value detail-input" value={userStreet ?? ''} onChange={(e) => setUserStreet(e.target.value)} placeholder="Street" />
                                                </div>
                                                <div className="detail-row">
                                                    <label className="detail-label">{stringsoflanguages.number}</label>
                                                    <input type="text" className="detail-value detail-input" value={userNumber ?? ''} onChange={(e) => setUserNumber(e.target.value)} placeholder="Number" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="detail-section my-social-channels">
                                            <h3 className="section-title">{stringsoflanguages.mySocialChannels}</h3>
                                            <div className="detail-content">
                                                <div className="detail-row">
                                                    <label className="detail-label"><svg height="512" viewBox="0 0 176 176" width="512" xmlns="http://www.w3.org/2000/svg" id="fi_3670051"><g id="Layer_2" data-name="Layer 2"><g id="_09.whatsapp" data-name="09.whatsapp"><circle id="background" cx="88" cy="88" fill="#29a71a" r="88"></circle><g id="icon" fill="#fff"><path d="m126.8 49.2a54.57 54.57 0 0 0 -87.42 63.13l-5.79 28.11a2.08 2.08 0 0 0 .33 1.63 2.11 2.11 0 0 0 2.24.87l27.55-6.53a54.56 54.56 0 0 0 63.09-87.21zm-8.59 68.56a42.74 42.74 0 0 1 -49.22 8l-3.84-1.9-16.89 4 .05-.21 3.5-17-1.88-3.71a42.72 42.72 0 0 1 7.86-49.59 42.73 42.73 0 0 1 60.42 0 2.28 2.28 0 0 0 .22.22 42.72 42.72 0 0 1 -.22 60.19z"></path><path d="m116.71 105.29c-2.07 3.26-5.34 7.25-9.45 8.24-7.2 1.74-18.25.06-32-12.76l-.17-.15c-12.09-11.21-15.23-20.54-14.47-27.94.42-4.2 3.92-8 6.87-10.48a3.93 3.93 0 0 1 6.15 1.41l4.45 10a3.91 3.91 0 0 1 -.49 4l-2.25 2.92a3.87 3.87 0 0 0 -.35 4.32c1.26 2.21 4.28 5.46 7.63 8.47 3.76 3.4 7.93 6.51 10.57 7.57a3.82 3.82 0 0 0 4.19-.88l2.61-2.63a4 4 0 0 1 3.9-1l10.57 3a4 4 0 0 1 2.24 5.91z"></path></g></g></g></svg> <span>Whatsapp</span> </label>
                                                    <input type="text" className="detail-value detail-input" value={userWhatsapp ?? ''} onChange={(e) => setUserWhatsapp(e.target.value)} placeholder="WhatsApp" />
                                                </div>
                                                <div className="detail-row">
                                                    <label className="detail-label"><svg height="512" viewBox="0 0 152 152" width="512" xmlns="http://www.w3.org/2000/svg" id="fi_3670176"><g id="Layer_2" data-name="Layer 2"><g id="Color"><g id="_13.Skype" data-name="13.Skype"><circle id="Background" cx="76" cy="76" fill="#03a9f4" r="76"></circle><path id="Icon" d="m113.62 84.45c5.79-26-17-49.64-43.75-45.11-14.53-9.01-33.87 1.17-33.87 18.46a21.5 21.5 0 0 0 3 11c-5.38 26.07 17.6 49.36 44.33 44.51 18.93 10.02 39.82-9.91 30.29-28.86zm-25.43 15.68c-7 2.89-18.58 2.91-25.57-.75-10-5.32-11.74-17.29-3.14-17.29 6.48 0 4.43 7.56 11 10.64 3 1.39 9.46 1.53 13.21-1s3.31-6.38 1.31-8.25c-5.34-4.93-20.61-3-27.6-11.6a12.54 12.54 0 0 1 .13-15.13c6.5-8.37 25.57-8.88 33.78-2.56 7.57 5.86 5.53 13.64-.59 13.64-7.35 0-3.48-9.62-15.35-9.62-8.6 0-12 6.12-5.93 9.1 8.24 4.08 29.16 2.69 29.16 18.69 0 6.63-4.08 11.58-10.41 14.16z" fill="#fff"></path></g></g></g></svg> <span>Skype</span></label>
                                                    <input type="text" className="detail-value detail-input" value={userSkype ?? ''} onChange={(e) => setUserSkype(e.target.value)} placeholder="Skype" />
                                                </div>
                                                <div className="detail-row">
                                                    <label className="detail-label"><svg id="fi_5968764" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg"><g><path d="m512 256c0 127.78-93.62 233.69-216 252.89v-178.89h59.65l11.35-74h-71v-48.02c0-20.25 9.92-39.98 41.72-39.98h32.28v-63s-29.3-5-57.31-5c-58.47 0-96.69 35.44-96.69 99.6v56.4h-65v74h65v178.89c-122.38-19.2-216-125.11-216-252.89 0-141.38 114.62-256 256-256s256 114.62 256 256z" fill="#1877f2"></path><path d="m355.65 330 11.35-74h-71v-48.021c0-20.245 9.918-39.979 41.719-39.979h32.281v-63s-29.296-5-57.305-5c-58.476 0-96.695 35.44-96.695 99.6v56.4h-65v74h65v178.889c13.034 2.045 26.392 3.111 40 3.111s26.966-1.066 40-3.111v-178.889z" fill="#fff"></path></g></svg> <span>Facebook</span></label>
                                                    <input type="text" className="detail-value detail-input" value={userFacebook ?? ''} onChange={(e) => setUserFacebook(e.target.value)} placeholder="Facebook" />
                                                </div>
                                                <div className="detail-row">
                                                    <label className="detail-label"><svg height="512" viewBox="0 0 152 152" width="512" xmlns="http://www.w3.org/2000/svg" id="fi_3955024"><linearGradient id="linear-gradient" gradientUnits="userSpaceOnUse" x1="22.26" x2="129.74" y1="22.26" y2="129.74"><stop offset="0" stop-color="#fae100"></stop><stop offset=".15" stop-color="#fcb720"></stop><stop offset=".3" stop-color="#ff7950"></stop><stop offset=".5" stop-color="#ff1c74"></stop><stop offset="1" stop-color="#6c1cd1"></stop></linearGradient><g id="Layer_2" data-name="Layer 2"><g id="Circle"><g id="_03.Instagram" data-name="03.Instagram"><rect id="Background" fill="url(#linear-gradient)" height="152" rx="76" width="152"></rect><g fill="#fff"><path id="Shade" d="m133.2 26c-11.08 20.34-26.75 41.32-46.33 60.9s-40.56 35.22-60.87 46.3q-1.91-1.66-3.71-3.46a76 76 0 1 1 107.45-107.48q1.8 1.8 3.46 3.74z" opacity=".1"></path><g id="Icon"><path d="m94 36h-36a22 22 0 0 0 -22 22v36a22 22 0 0 0 22 22h36a22 22 0 0 0 22-22v-36a22 22 0 0 0 -22-22zm15 54.84a18.16 18.16 0 0 1 -18.16 18.16h-29.68a18.16 18.16 0 0 1 -18.16-18.16v-29.68a18.16 18.16 0 0 1 18.16-18.16h29.68a18.16 18.16 0 0 1 18.16 18.16z"></path><path d="m90.59 61.56-.19-.19-.16-.16a20.16 20.16 0 0 0 -14.24-5.88 20.52 20.52 0 0 0 -20.38 20.67 20.75 20.75 0 0 0 6 14.61 20.19 20.19 0 0 0 14.42 6 20.73 20.73 0 0 0 14.55-35.05zm-14.59 28a13.56 13.56 0 1 1 13.37-13.56 13.46 13.46 0 0 1 -13.37 13.56z"></path><path d="m102.43 54.38a4.88 4.88 0 0 1 -4.85 4.92 4.81 4.81 0 0 1 -3.42-1.43 4.93 4.93 0 0 1 3.43-8.39 4.82 4.82 0 0 1 3.09 1.12l.1.1a3.05 3.05 0 0 1 .44.44l.11.12a4.92 4.92 0 0 1 1.1 3.12z"></path></g></g></g></g></g></svg> <span>Instagram</span></label>
                                                    <input type="text" className="detail-value detail-input" value={userInstagram ?? ''} onChange={(e) => setUserInstagram(e.target.value)} placeholder="Instagram" />
                                                </div>
                                                <div className="detail-row">
                                                    <label className="detail-label"><svg id="fi_5968804" height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg"><linearGradient id="Oval_00000153700382965497781030000014141664724916521630_" gradientTransform="matrix(1000 0 0 -1000 1981017 6242157)" gradientUnits="userSpaceOnUse" x1="-1980.761" x2="-1980.761" y1="6242.157" y2="6241.649"><stop offset="0" stop-color="#2aabee"></stop><stop offset="1" stop-color="#229ed9"></stop></linearGradient><g id="Artboard" clipRule="evenodd" fillRule="evenodd"><circle id="Oval" cx="256" cy="256" fill="url(#Oval_00000153700382965497781030000014141664724916521630_)" r="256"></circle><path id="Path-3" d="m115.88 253.298c74.629-32.515 124.394-53.951 149.293-64.307 71.094-29.57 85.867-34.707 95.495-34.877 2.118-.037 6.853.488 9.92 2.977 4.55 3.692 4.576 11.706 4.071 17.01-3.853 40.48-20.523 138.713-29.004 184.051-3.589 19.184-10.655 25.617-17.495 26.246-14.866 1.368-26.155-9.825-40.554-19.263-22.531-14.77-35.26-23.964-57.131-38.376-25.275-16.656-8.89-25.81 5.514-40.771 3.77-3.915 69.271-63.494 70.539-68.899.159-.676.306-3.196-1.191-4.526s-3.706-.876-5.3-.514c-2.26.513-38.254 24.304-107.982 71.372-10.217 7.016-19.471 10.434-27.762 10.255-9.141-.197-26.723-5.168-39.794-9.417-16.032-5.211-28.774-7.967-27.664-16.817.578-4.611 6.926-9.325 19.045-14.144z" fill="#fff"></path></g></svg> <span>Telegram</span></label>
                                                    <input type="text" className="detail-value detail-input" value={userTelegram ?? ''} onChange={(e) => setUserTelegram(e.target.value)} placeholder="Telegram" />
                                                </div>
                                                <div className="detail-row">
                                                    <label className="detail-label"><svg height="512" viewBox="0 0 152 152" width="512" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><g><g><circle cx="76" cy="76" fill="#0b69c7" r="76" /><g fill="#fff"><path d="m59 48.37a10.38 10.38 0 1 1 -10.37-10.37 10.38 10.38 0 0 1 10.37 10.37z" /><rect height="50.93" rx="2.57" width="16.06" x="40.6" y="63.07" /><path d="m113.75 89.47v22.17a2.36 2.36 0 0 1 -2.36 2.36h-11.72a2.36 2.36 0 0 1 -2.36-2.36v-21.48c0-3.21.93-14-8.38-14-7.22 0-8.69 7.42-9 10.75v24.78a2.36 2.36 0 0 1 -2.34 2.31h-11.34a2.35 2.35 0 0 1 -2.36-2.36v-46.2a2.36 2.36 0 0 1 2.36-2.37h11.34a2.37 2.37 0 0 1 2.41 2.37v4c2.68-4 6.66-7.12 15.13-7.12 18.73-.01 18.62 17.52 18.62 27.15z" /></g></g></g></svg> <span>LinkedIn</span></label>
                                                    <input type="text" className="detail-value detail-input" value={userLinkedIn ?? ''} onChange={(e) => setUserLinkedIn(e.target.value)} placeholder="LinkedIn" />
                                                </div>



                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>

            {isMobile && (
                <nav className="mobile-bottom-nav liquidGlass-wrapper dock profile-footer-nav" aria-label="Profile actions">
                    <div className="liquidGlass-effect" aria-hidden="true" />
                    <div className="liquidGlass-shine" aria-hidden="true" />
                    {activeRightSection === 'web-settings' ? (
                        <button
                            type="button"
                            className="mobile-nav-item"
                            onClick={() => {
                                const agentCode = String(userAgentCode ?? '').trim();
                                if (!agentCode) {
                                    showNotification('Error', 'Agent code is missing', 'danger');
                                    return;
                                }
                                window.open(`http://yesmlspremium.com/${agentCode}`, '_blank', 'noopener,noreferrer');
                            }}
                            aria-label="Weblink"
                        >
                            <i className="fa-solid fa-link"></i>
                        </button>
                    ) : (
                        <>
                            <button type="button" className="mobile-nav-item" onClick={() => handleGearOptionClick('logout')} aria-label="Logout">
                                <svg id="fi_2529508" height="512" viewBox="0 0 6.3499999 6.3500002" width="512" fill='#fff' ><g id="layer1" transform="translate(0 -290.65)"><path id="path52" d="m3.1721577 291.17917a.26463566.26580324 0 0 0 -.262025.26889v2.12674a.26486756.26603617 0 0 0 .5297351 0v-2.12674a.26463566.26580324 0 0 0 -.2677101-.26889zm1.5437259.53311a.26463566.26580324 0 0 0 -.025842.00052.26463566.26580324 0 0 0 -.1467753.46926c.4583643.39096.7483457.97287.7483479 1.62632.0000018 1.17989-.9432648 2.13089-2.1153231 2.13089-1.1720581 0-2.1173921-.951-2.1173901-2.13089.000002-.64967.2862991-1.22762.7400788-1.61853a.26467261.26584036 0 1 0 -.343681-.40438c-.5664588.48798-.92612958 1.21533-.92613207 2.02291-.00000238 1.46669 1.18858337 2.66244 2.64712517 2.66244 1.4585422 0 2.6445438-1.19575 2.6445414-2.66244-.0000027-.81229-.3632264-1.54263-.9354347-2.03069a.26463566.26580324 0 0 0 -.1695153-.0654z" font-variant-ligatures="normal" font-variant-position="normal" font-variant-caps="normal" font-variant-numeric="normal" font-variant-alternates="normal" font-feature-settings="normal" text-indent="0" text-align="start" text-decoration-line="none" text-decoration-style="solid" text-decoration-color="rgb(0,0,0)" text-transform="none" text-orientation="mixed" white-space="normal" shape-padding="0" isolation="auto" mix-blend-mode="normal" solid-color="rgb(255,255,255)" solid-opacity="1" vector-effect="none"></path></g></svg>
                            </button>
                            <button type="button" className="mobile-nav-item" onClick={() => handleGearOptionClick('push-notification')} aria-label="Push Notification">
                                <i className="fa-solid fa-bell"></i>
                            </button>
                            <button type="button" className="mobile-nav-item" onClick={() => handleGearOptionClick('change-password')} aria-label="Change Password">
                                <svg height="512" viewBox="0 0 56 56" width="512" xmlns="http://www.w3.org/2000/svg" id="fi_3257166" fill='#fff'><g id="Page-1" fill="none" fill-rule="evenodd"><g id="010---Secure-Password" fill="rgb(255,255,255)" fill-rule="nonzero"><path id="Shape" d="m48 25c0-1.6568542-1.3431458-3-3-3h-34c-1.65685425 0-3 1.3431458-3 3v6h40zm-34 1h-2v2c0 .5522847-.4477153 1-1 1s-1-.4477153-1-1v-3c0-.5522847.4477153-1 1-1h3c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z"></path><path id="Shape" d="m8 53c0 1.6568542 1.34314575 3 3 3h34c1.6568542 0 3-1.3431458 3-3v-6h-40z"></path><path id="Shape" d="m55 33h-54c-.55228475 0-1 .4477153-1 1v10c0 .5522847.44771525 1 1 1h54c.5522847 0 1-.4477153 1-1v-10c0-.5522847-.4477153-1-1-1zm-45.445 7.168c.4595009.306518.583518.9274991.27699996 1.387-.30651803.4595009-.92749905.583518-1.38699996.277l-1.445-.964v1.132c0 .5522847-.44771525 1-1 1s-1-.4477153-1-1v-1.132l-1.445.964c-.45950091.306518-1.08048193.1825009-1.38699996-.277s-.18250092-1.080482.27699996-1.387l1.755-1.168-1.755-1.168c-.45950088-.306518-.58351799-.9274991-.27699996-1.387s.92749905-.583518 1.38699996-.277l1.445.964v-1.132c0-.5522847.44771525-1 1-1s1 .4477153 1 1v1.132l1.445-.964c.29724497-.1982824.67769307-.2229246.99803316-.0646441.3203401.1582805.53190491.4754371.55500002.832.02309512.3565629-.14578819.6983617-.44303318.8966441l-1.755 1.168zm11 0c.4595009.306518.583518.9274991.277 1.387-.3065181.4595009-.9274991.583518-1.387.277l-1.445-.964v1.132c0 .5522847-.4477153 1-1 1s-1-.4477153-1-1v-1.132l-1.445.964c-.4595009.306518-1.0804819.1825009-1.387-.277-.306518-.4595009-.1825009-1.080482.277-1.387l1.755-1.168-1.752-1.168c-.4595009-.306518-.583518-.9274991-.277-1.387.3065181-.4595009.9274991-.583518 1.387-.277l1.442.964v-1.132c0-.5522847.4477153-1 1-1s1 .4477153 1 1v1.132l1.445-.964c.297245-.1982824.6776931-.2229246.9980332-.0646441s.5319049.4754371.555.832-.1457882.6983617-.4430332.8966441l-1.755 1.168zm11 0c.4595009.3065181.583518.9274991.2769999 1.387-.306518.4595009-.927499.583518-1.3869999.277l-1.445-.964v1.132c0 .5522847-.4477153 1-1 1s-1-.4477153-1-1v-1.132l-1.445.964c-.4595009.306518-1.0804819.1825009-1.387-.277-.306518-.4595009-.1825009-1.080482.277-1.387l1.755-1.168-1.752-1.168c-.4595009-.3065181-.583518-.9274991-.2769999-1.387.306518-.4595009.927499-.583518 1.3869999-.277l1.442.964v-1.132c0-.5522847.4477153-1 1-1s1 .4477153 1 1v1.132l1.445-.964c.297245-.1982824.6776931-.2229246.9980332-.0646441.3203401.1582804.5319049.4754371.555.832s-.1457882.6983617-.4430332.8966441l-1.755 1.168zm11 0c.4595009.306518.583518.9274991.277 1.387-.3065181.4595009-.9274991.583518-1.387.277l-1.445-.964v1.132c0 .5522847-.4477153 1-1 1s-1-.4477153-1-1v-1.132l-1.445.964c-.4595009.306518-1.0804819.1825009-1.3869999-.277-.3065181-.4595009-.182501-1.0804819.2769999-1.387l1.755-1.168-1.752-1.168c-.4595009-.306518-.583518-.9274991-.277-1.387.3065181-.4595009.9274991-.583518 1.387-.277l1.442.964v-1.132c0-.5522847.4477153-1 1-1s1 .4477153 1 1v1.132l1.445-.964c.297245-.1982824.6776931-.2229246.9980332-.0646441.32034.1582805.5319049.4754371.555.832s-.1457882.6983617-.4430332.8966441l-1.755 1.168zm10.445 2.832h-6c-.5522847 0-1-.4477153-1-1s.4477153-1 1-1h6c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z"></path><path id="Shape" d="m17 15c0-6.07513225 4.9248678-11 11-11s11 4.92486775 11 11v5h4v-5c0-8.28427125-6.7157288-15-15-15s-15 6.71572875-15 15v5h4z"></path></g></g></svg>
                            </button>
                            <button type="button" className="mobile-nav-item" onClick={() => handleGearOptionClick('change-email')} aria-label="Change Email">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M3.33333 3.33333H16.6667C17.5833 3.33333 18.3333 4.08333 18.3333 5V15C18.3333 15.9167 17.5833 16.6667 16.6667 16.6667H3.33333C2.41667 16.6667 1.66667 15.9167 1.66667 15V5C1.66667 4.08333 2.41667 3.33333 3.33333 3.33333ZM3.33333 5L10 9.16667L16.6667 5H3.33333ZM16.6667 15V6.66667L10 10.8333L3.33333 6.66667V15H16.6667Z" fill="#fff" />
                                </svg>
                            </button>
                            <button type="button" className="mobile-nav-item" onClick={() => handleGearOptionClick('share')} aria-label="Share">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M15 10.8333V15.8333C15 16.75 14.25 17.5 13.3333 17.5H4.16667C3.25 17.5 2.5 16.75 2.5 15.8333V6.66667C2.5 5.75 3.25 5 4.16667 5H9.16667" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M12.5 2.5H17.5V7.5" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M8.33333 11.6667L17.5 2.5" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                            <button type="button" className="mobile-nav-item" onClick={() => handleGearOptionClick('web-settings')} aria-label="Web Settings">
                                <svg clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" id="fi_13446270"><g transform="translate(-96 -96)"><path d="m98.586 118.715c-1.015-2.02-1.586-4.302-1.586-6.715s.571-4.695 1.586-6.715c2.465-4.912 7.549-8.285 13.414-8.285s10.949 3.373 13.414 8.285c1.015 2.02 1.586 4.302 1.586 6.715s-.571 4.695-1.586 6.715c-2.465 4.912-7.549 8.285-13.414 8.285s-10.949-3.373-13.414-8.285zm1.4-11.688c-.635 1.532-.986 3.212-.986 4.973s.351 3.441.986 4.973c1.633-.633 3.558-1.141 5.683-1.483-.11-1.118-.169-2.287-.169-3.49s.059-2.372.169-3.49c-2.125-.342-4.05-.85-5.683-1.483zm23.115-1.791c-1.655-2.709-4.273-4.765-7.376-5.693.139.216.274.445.404.687.853 1.593 1.535 3.769 1.945 6.298 1.868-.303 3.569-.744 5.027-1.292zm-14.826-5.693c-3.103.928-5.721 2.984-7.376 5.693 1.458.549 3.159.989 5.027 1.292.41-2.529 1.092-4.705 1.945-6.298.13-.242.265-.471.404-.687zm15.739 17.43c.635-1.532.986-3.212.986-4.973s-.351-3.441-.986-4.973c-1.633.633-3.558 1.141-5.683 1.483.11 1.118.169 2.287.169 3.49s-.059 2.372-.169 3.49c2.125.342 4.05.85 5.683 1.483zm-23.115 1.791c1.655 2.709 4.273 4.765 7.376 5.693-.139-.216-.274-.445-.404-.687-.853-1.593-1.535-3.769-1.945-6.298-1.868.303-3.569.744-5.027 1.292zm14.826 5.693c3.103-.928 5.721-2.984 7.376-5.693-1.458-.548-3.159-.989-5.027-1.292-.41 2.529-1.092 4.705-1.945 6.298-.13.242-.265.471-.404.687zm-3.725-25.457c-.385 0-.745.183-1.091.477-.464.394-.888.975-1.275 1.698-.764 1.426-1.364 3.365-1.73 5.616 1.31.137 2.682.209 4.096.209s2.786-.073 4.096-.209c-.366-2.251-.966-4.19-1.73-5.616-.387-.723-.811-1.304-1.275-1.698-.346-.294-.706-.477-1.091-.477zm0 26c.385 0 .745-.183 1.091-.477.464-.394.888-.975 1.275-1.698.764-1.426 1.364-3.365 1.73-5.616-1.31-.136-2.682-.209-4.096-.209s-2.786.073-4.096.209c.366 2.251.966 4.19 1.73 5.616.387.723.811 1.304 1.275 1.698.346.294.706.477 1.091.477zm4.35-9.773c.098-1.034.15-2.115.15-3.227s-.052-2.193-.15-3.227c-1.391.148-2.849.227-4.35.227s-2.959-.079-4.35-.227c-.098 1.034-.15 2.115-.15 3.227s.052 2.193.15 3.227c1.391-.148 2.849-.227 4.35-.227s2.959.079 4.35.227z" fill='#fff' strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path></g></svg>
                            </button>
                        </>
                    )}
                </nav>
            )}

            {defaultThemeModalOpen && (
                <>
                    <div className="modal-overlay" onClick={() => setDefaultThemeModalOpen(false)} aria-hidden="true" />
                    <div className="logout-modal default-theme-modal" role="dialog" aria-modal="true" aria-labelledby="default-theme-modal-title">
                        <h3 id="default-theme-modal-title" style={{ margin: '0 0 15px 0', fontSize: '20px', fontWeight: '600', color: '#fff' }}>
                            Select Default Theme
                        </h3>
                        <div className="default-theme-grid">
                            {defaultThemeImages.length === 0 ? (
                                <p className="text-white">No default images found.</p>
                            ) : (
                                defaultThemeImages.map((item) => (
                                    <button
                                        key={item.id}
                                        type="button"
                                        className={`default-theme-item ${selectedThemeImage === item.image ? 'active' : ''}`}
                                        onClick={() => { handleSelectDefaultThemeImage(item.image); setThemeImage('0', item.id, ''); }}
                                        aria-label={item.title || 'Theme'}
                                    >
                                        <img src={item.image} alt={item.alt_name || item.title || 'Theme'} />
                                        {/* <span>{item.title || 'Theme'}</span> */}
                                    </button>
                                ))
                            )}
                        </div>
                        <div className='btn-sec'>
                            <button type="button" className="cancel-btn custom-btn" onClick={() => setDefaultThemeModalOpen(false)}>
                                Close
                            </button>
                        </div>
                    </div>
                </>
            )}

            {showEmailLockedModal && (
                <>
                    <div className="modal-overlay" onClick={() => setShowEmailLockedModal(false)} aria-hidden="true" />
                    <div className="logout-modal" role="dialog" aria-modal="true" aria-labelledby="email-locked-modal-title">
                        <h3 id="email-locked-modal-title" style={{ margin: '0 0 15px 0', fontSize: '20px', fontWeight: '600', color: '#fff' }}>
                            Email Address
                        </h3>
                        <p style={{ margin: '0 0 25px 0', fontSize: '16px', color: '#fff', lineHeight: '1.5' }}>
                            You can not edit email address
                        </p>
                        <div className="btn-sec">
                            <button type="button" className="save-btn custom-btn" onClick={() => setShowEmailLockedModal(false)}>
                                OK
                            </button>
                        </div>
                    </div>
                </>
            )}

            {/* Leave profile – save changes confirmation (in-app navigation or reload) */}
            {(blocker.state === 'blocked' || showLeaveModalForReload) && (
                <>
                    <div
                        className="modal-overlay"
                        onClick={isSavingOnLeave ? undefined : (showLeaveModalForReload ? handleLeaveCancelReload : handleLeaveCancel)}
                        aria-hidden="true"
                    />
                    <div className="logout-modal" role="dialog" aria-modal="true" aria-labelledby="leave-profile-title">
                        <h3 id="leave-profile-title" style={{ margin: '0 0 15px 0', fontSize: '20px', fontWeight: '600', color: '#fff' }}>
                            Unsaved changes
                        </h3>
                        <p style={{ margin: '0 0 25px 0', fontSize: '16px', color: '#fff', lineHeight: '1.5' }}>
                            You have unsaved changes. Do you want to save before leaving?
                        </p>
                        {isSavingOnLeave ? (
                            <div className="react-js-loader" style={{ padding: '20px 0' }}>
                                <div className="react-js-loader-spinner"></div>
                                <p className="react-js-loader-text" style={{ color: '#fff' }}>Saving...</p>
                            </div>
                        ) : (
                            <div className="btn-sec">
                                <button
                                    type="button"
                                    className="cancel-btn custom-btn"
                                    onClick={showLeaveModalForReload ? handleLeaveCancelReload : handleLeaveCancel}
                                >
                                    No
                                </button>
                                <button
                                    type="button"
                                    className="save-btn custom-btn"
                                    onClick={showLeaveModalForReload ? handleLeaveConfirmReload : handleLeaveConfirm}
                                >
                                    Yes
                                </button>
                            </div>
                        )}
                    </div>
                </>
            )}

            {/* Logout Confirmation Modal */}
            {isLogoutModalOpen && (
                <>
                    <div
                        className="modal-overlay"
                        onClick={handleLogoutCancel}

                    />
                    <div
                        className="logout-modal"

                    >
                        <h3 style={{
                            margin: '0 0 15px 0',
                            fontSize: '20px',
                            fontWeight: '600',
                            color: '#fff'
                        }}>
                            Confirm Logout
                        </h3>
                        <p style={{
                            margin: '0 0 25px 0',
                            fontSize: '16px',
                            color: '#fff',
                            lineHeight: '1.5'
                        }}>
                            Are you sure you want to logout?
                        </p>
                        <div className='btn-sec'>
                            <button className='cancel-btn custom-btn'
                                onClick={handleLogoutCancel}

                            >
                                No
                            </button>
                            <button className='save-btn custom-btn'
                                onClick={handleLogoutConfirm}

                            >
                                Yes
                            </button>
                        </div>
                    </div>
                </>
            )}

            {/* Profile image cropper modal */}
            {isCropperOpen && (
                <>
                    <div className="modal-overlay" onClick={handleCropCancel} aria-hidden="true" />
                    <div className="logout-modal" role="dialog" aria-modal="true" aria-labelledby="profile-cropper-title">
                        <h3 id="profile-cropper-title" style={{ margin: '0 0 15px 0', fontSize: '20px', fontWeight: '600', color: '#fff' }}>
                            Crop Image
                        </h3>
                        <div style={{ position: 'relative', width: '100%', height: '280px', background: '#111', borderRadius: '12px', overflow: 'hidden' }}>
                            <Cropper
                                image={cropperImageSrc}
                                crop={crop}
                                zoom={zoom}
                                aspect={1}
                                onCropChange={setCrop}
                                onZoomChange={setZoom}
                                onCropComplete={onCropComplete}
                            />
                        </div>
                        <div style={{ marginTop: '16px' }}>
                            <input
                                type="range"
                                min={1}
                                max={3}
                                step={0.1}
                                value={zoom}
                                onChange={(e) => setZoom(Number(e.target.value))}
                                style={{ width: '100%' }}
                                aria-label="Zoom"
                            />
                        </div>
                        <div className="btn-sec" style={{ marginTop: '18px' }}>
                            <button type="button" className="cancel-btn custom-btn" onClick={handleCropCancel} disabled={isUploadingAnyImage}>
                                No
                            </button>
                            <button type="button" className="save-btn custom-btn" onClick={handleCropSave} disabled={isUploadingAnyImage}>
                                {isUploadingAnyImage ? 'Uploading...' : 'Yes'}
                            </button>
                        </div>
                    </div>
                </>
            )}

            {/* Uploading overlay */}
            {isUploadingAnyImage && (
                <>
                    <div className="modal-overlay" aria-hidden="true" />
                    <div className="logout-modal" role="dialog" aria-modal="true" aria-labelledby="uploading-profile-image-title">
                        <h3 id="uploading-profile-image-title" style={{ margin: '0 0 15px 0', fontSize: '20px', fontWeight: '600', color: '#fff' }}>
                            Uploading
                        </h3>
                        <div className="react-js-loader" style={{ padding: '10px 0 0 0' }}>
                            <div className="react-js-loader-spinner"></div>
                            <p className="react-js-loader-text" style={{ color: '#fff' }}>Please wait...</p>
                        </div>
                    </div>
                </>
            )}
        </>
    );
}